import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  es: {
    translation: {
      nav: {
        home: "Inicio",
        menu: "Menú",
        salones: "Salones",
        about: "Nosotros",
        contact: "Contacto"
      },
      hero: {
        title: "Experiencia Premium",
        subtitle: "en Carnes y Mariscos",
        description: "Disfruta de los cortes más selectos en un ambiente de elegancia y calidez",
        viewMenu: "Ver Menú"
      },
      about: {
        title: "Nuestra Historia",
        text1: "En SOLO CARNES & AQUARIUM, fusionamos la tradición culinaria con la excelencia contemporánea. Nos especializamos en carnes premium y los mejores frutos del mar.",
        text2: "Cada plato es una obra maestra elaborada con ingredientes de la más alta calidad, preparados por nuestros chefs expertos en un ambiente que combina calidez y sofisticación.",
        years: "Años de Experiencia",
        premium: "Carnes Premium",
        rating: "Calificación"
      },
      salones: {
        title: "Nuestros Espacios",
        subtitle: "Ambientes únicos para cada ocasión",
        cta: "Reservar Ahora",
        spaces: {
          principal: {
            name: "Salón Principal",
            capacity: "Hasta 80 personas",
            description: "Nuestro espacio más amplio y elegante, perfecto para celebraciones grandes, eventos corporativos y banquetes. Cuenta con iluminación ambiental regulable, sistema de sonido profesional y decoración sofisticada.",
            features: ["Aire acondicionado", "Sistema de sonido", "Iluminación ambiental", "Acceso para personas con movilidad reducida"]
          },
          estacionamiento: {
            name: "Estacionamiento",
            capacity: "De 15 a 30 vehiculos",
            description: "Amplio estacionamiento privado con espacio para discapacitados.",
            features: ["Totalmente privado", "Servicio exclusivo"]
          },
          exterior: {
            name: "Exterior",
            capacity: "Hasta 50 personas",
            description: "Disfruta de una experiencia al aire libre en nuestro hermoso exterior. Perfecto para eventos diurnos, cócteles y celebraciones informales con vista panorámica y ambiente relajado.",
            features: ["Al aire libre", "Vista panorámica", "Calefacción exterior", "Ambiente natural"]
          },
          lounge: {
            name: "Lounge & Bar",
            capacity: "Hasta 20 personas",
            description: "Espacio versátil con ambiente moderno y sofisticado. Ideal para after-office, cócteles empresariales y reuniones sociales. Cuenta con barra completa y zona de sofás confortables.",
            features: ["Barra completa", "Música ambiental"]
          },
          bano: {
            name: "Baños",
            capacity: "4 personas",
            description: "Espacio sanitizado y elegante.",
            features: ["Sanitizado", "Música ambiental"]
          },
          salonAquarium: {
            name: "Salón Aquarium",
            capacity: "15 personas",
            description: "Espacio elegante, reservado para Reuniones, Fiestas de Cumpleaños y/o Eventos Corporativos.",
            features: ["Televisión", "Aire acondicionado", "Salón privado"]
          },
        },
        events: {
          title: "Eventos Especiales",
          description: "Organizamos todo tipo de celebraciones",
          types: ["Bodas y Aniversarios", "Eventos Corporativos", "Cumpleaños y Celebraciones", "Reuniones de Negocios"]
        }
      },
      menu: {
        title: "Nuestro Menú",
        subtitle: "Descubre nuestras especialidades",
        categories: {
          "entradas-frias": "Entradas Frías",
          "entradas-calientes": "Entradas Calientes",
          "agregados":"Agregados",
          "sopas-cremas": "Sopas y Cremas",
          "ensaladas": "Ensaladas",
          "carnes": "Carnes Premium",
          "pescados": "Pescados",
          "pastas": "Pastas Frescas",
          "veganos": "Platos Veganos",
          "celiacos": "Platos para Celíacos",
          "salsas" : "Salsas",
          "postres": "Postres",
          "tablas": "Tablas y Picoteos",
          "vinos": "Carta de Vinos",
          "cervezas": "Cervezas",
          "cocteleria": "Coctelería",
          "espumantes": "Espumantes",
          "jugos-bebidas": "Jugos y Bebidas"
        }
      },
      menuItems: {
        'entradas-frias': {
          'carpaccio-de-atun': {name: 'Carpaccio de Atún', desc: 'Finas láminas de atún, condimentadas con dressing de mostaza de Dijón, mayonesa y jugo de limón, acompañadas con alcaparras y queso gruyere.'},
          'carpaccio-de-filete': {name: 'Carpaccio de Filete', desc: 'Finas láminas de filete, condimentadas con dressing de mostaza de Dijón, mayonesa y jugo de limón, acompañadas con alcaparras y queso gruyere.'},
          'carpaccio-de-salmon': {name: 'Carpaccio de Salmón', desc: 'Finas láminas de salmón, condimentadas con dressing de mostaza de Dijón, mayonesa y jugo de limón, acompañadas con alcaparras y queso gruyere.'},
          'centolla-del-mar-del-sur': {name: 'Centolla del Mar del Sur', desc: 'Exquisita Carne de Centolla, cocida al vapor, acompañada de mayonesa y salsa verde.'},
          'ceviche-acapulco': {name: 'Ceviche Acapulco', desc: 'Sabroso pescado fresco del día cortado en cubos y marinado en jugo de limón, pimiento morrón, cebolla morada, palta, cilantro, sal y pimienta.'},
          'ceviche-de-locos': {name: 'Ceviche de Locos', desc: 'Exquisitos cubos de locos marinados en jugo de limón, pimiento morrón, cebolla morada, cilantro, sal y pimienta.'},
          'ceviche-de-pulpo': {name: 'Ceviche de Pulpo', desc: 'Sabrosos trozos de pulpo marinados en jugo de limón, pimiento morrón, cebolla morada, cilantro, sal y pimienta.'},
          'ceviche-estilo-mexicano': {name: 'Ceviche Estilo Mexicano', desc: 'Sabrosas combinaciones de pescado y palta cortadas en cubos, marinadas en jugo de limón, pimiento morrón, cebolla morada, cilantro, ají verde.'},
          'ceviche-de-salmon-acapulco': {name: 'Ceviche de Salmón Acapulco', desc: 'Deliciosa combinación de salmon, locos y camarones acompañado de cebolla morada mix de pimentón y palta aliñados con jugo de limón, sal, pimienta y Leche de Tigre.'},
          'ceviche-tropical': {name: 'Ceviche Tropical', desc: 'Fresca preparación de salmón marinado en jugo de limón, pimiento morrón, trozos de mango, leche de coco, cilantro.'},
          'locos-en-salsa-verde': {name: 'Locos en Salsa Verde', desc: 'Deliciosos Locos Premium, acompañados de mayonesa y salsa verde. Opcional ensalada de papas con mayonesa.'},
          'tartara-de-filete': {name: 'Tártara de Filete', desc: 'Finos cortes de filete, aderezados con alcaparras, tártara, cebolla y cilantro, con un toque de mostaza, limón y mayonesa.'},
          'crudo-de-filete': {name: 'Crudo de Filete', desc: 'Finos cortes de filete, aderezados con cebolla y cilantro, con un toque de limón, sal, pimienta y aceite de oliva.'},
        },
        'entradas-calientes': {
          'brocheta-de-camarones-y-jamon-serrano': {name: 'Brocheta de Camarones y Jamón Serrano', desc: 'Deliciosas colas de Camarón Ecuatoriano envueltas en jamón serrano, con salsa de tomates, orégano y aceitunas negras.'},
          'camarones-ecuatorianos-a-la-primavera': {name: 'Camarones Ecuatorianos a la Primavera', desc: 'Colas de Camarones Ecuatorianos salteadas con cebollas, pimientos y tomates cherry. Aromatizadas con vino blanco y merquén.'},
          'camarones-al-ajillo': {name: 'Camarones al Ajillo', desc: 'Camarones Ecuatorianos salteados con ajo, aromatizados con vino blanco y pimienta.'},
          'camarones-al-olivo': {name: 'Camarones al Olivo', desc: 'Camarones Ecuatorianos salteados en aceite de oliva con un toque de pimienta.'},
          'camarones-al-pil-pil': {name: 'Camarones al Pil Pil', desc: 'Camarones salteados con ajo y ají cacho de cabra, aromatizados con vino blanco, pimienta y perejil.'},
          'langosta-de-juan-fernandez': {name: 'Langosta de Juan Fernández', desc: 'Exquisito crustáceo hervido en fondo de mariscos y horneado con mantequilla a las finas hierbas, aromatizado con whisky.'},
          'machas-a-la-parmesana': {name: 'Machas a la Parmesana', desc: 'Sabrosas lenguas de machas del norte, bañadas con salsa de tres quesos y gratinadas con parmesano.'},
          'ostiones-a-la-parmesana': {name: 'Ostiones a la Parmesana', desc: 'Sabrosos Ostiones bañados con salsa de tres quesos y gratinados con queso parmesano.'},
          'pulpo-a-la-parrilla': {name: 'Pulpo a la Parrilla', desc: 'Exquisitos tentáculos de Pulpo asados a la parrilla, macerados en aceite de oliva con paprika, ajo y orégano.'},
          'pulpo-salteado-al-ajillo': {name: 'Pulpo Salteado al Ajillo', desc: 'Tentáculos de Pulpo salteados con ajo, paprika y vino blanco.'},
          'pulpo-salteado-al-pil-pil': {name: 'Pulpo Salteado al Pil Pil', desc: 'Pulpo salteado con ajo, paprika y ají cacho de cabra, aromatizado con vino blanco.'},
          'centolla-entera': {name: 'Centolla Entera', desc: 'Exquisito crustáceo marino hervido en fondo de mariscos, montado en un mix verde y relleno de carne de centolla. Peso aproximado: 3 kg.'},
        },
        'agregados':{
          'anillos-de-cebolla': { name: 'Anillos de Cebolla', desc: '' },
          'arroz': { name: 'Arroz', desc: '' },
          'champinones-salteados': { name: 'Champiñones Salteados', desc: '' },
          'choclo-a-la-crema': { name: 'Choclo a la Crema', desc: '' },
          'espinacas-a-la-crema': { name: 'Espinacas a la Crema', desc: '' },
          'panache-de-verduras': { name: 'Panaché de Verduras', desc: '' },
          'papas-a-la-crema-acida': { name: 'Papas a la Crema Ácida', desc: '' },
          'papas-chauchas': { name: 'Papas Chauchas', desc: '' },
          'papas-cocidas': { name: 'Papas Cocidas', desc: '' },
          'papas-duquesas': { name: 'Papas Duquesas', desc: '' },
          'papas-fritas': { name: 'Papas Fritas', desc: '' },
          'papas-hilo': { name: 'Papas Hilo', desc: '' },
          'papas-salteadas': { name: 'Papas Salteadas', desc: '' },
          'pure-de-papas': { name: 'Puré de Papas', desc: '' },
          'pure-de-zapallo': { name: 'Puré de Zapallo', desc: '' },
          'pure-gratinado': { name: 'Puré Gratinado', desc: '' }
        },
        'sopas-cremas': {
          'ajiaco': {name: 'Ajiaco', desc: 'Deliciosa preparación hecha a base de carne, cebolla, papa y morrón. Opcional Ají Cacho de Cabra.'},
          'calderete-de-langosta': {name: 'Calderete de Langosta', desc: 'Exquisito caldo de bisque de crustáceos, carne de langosta, verduras y papas con cilantro fresco.'},
          'caldillo-de-congrio': {name: 'Caldillo de Congrio', desc: 'Tradicional caldo chileno de fumet de pescado, congrio dorado, verduras y papas con cilantro.'},
          'crema-de-centolla': {name: 'Crema de Centolla', desc: 'Exquisita crema de carne de centolla con sofrito, caldo de verduras y crema fresca.'},
          'crema-de-puerros': {name: 'Crema de Puerros', desc: 'Deliciosa crema de puerros y verduras frescas, caldo de verduras y crema fresca.'},
          'crema-de-zapallo': {name: 'Crema de Zapallo', desc: 'Crema natural preparada con zapallo, verduras y un suave toque de crema fresca.'},
          'crema-de-tomate': {name: 'Crema de Tomate', desc: 'Crema natural de tomates frescos con verduras y crema fresca.'},
          'crema-de-esparragos': {name: 'Crema de Espárragos', desc: 'Deliciosa crema de espárragos frescos con caldo de verduras.'},
          'sopa-aquarium': {name: 'Sopa Aquarium', desc: 'Delicioso caldo de fumet de pescado, congrio y surtido de mariscos, aromatizado con vino blanco.'},
          'consome-ave-reina': {name: 'Consomé Ave Reina', desc: 'Delicioso caldo de pollo con trozos de pollo y verduras.'},
        },
        'ensaladas': {
          'ensalada-cesar': {name: 'Ensalada César', desc: 'Exquisita ensalada de lechuga, rúcula, queso pecorino en láminas, crutones y aliño francés.'},
          'ensalada-cesar-con-camarones': {name: 'Ensalada César con Camarones', desc: 'Lechuga, rúcula, queso pecorino, camarón apanado en panko, crutones y aliño francés.'},
          'ensalada-cesar-con-pollo': {name: 'Ensalada César con Pollo', desc: 'Lechuga, rúcula, queso pecorino, pollo apanado en panko, crutones y aliño francés.'},
          'ensalada-cesar-con-pollo-y-camarones': {name: 'Ensalada César con Pollo y Camarones', desc: 'Lechuga con queso pecorino, crutones, pollo y camarón, aliño francés.'},
          'ensalada-de-manzanas': {name: 'Ensalada de Manzanas', desc: 'Sabrosa combinación de lechuga, champiñones, choclo, nueces y manzanas rojas y/o verdes.'},
          'ensalada-griega': {name: 'Ensalada Griega', desc: 'Fresca combinación de tomates, cebolla perla y morada, pimiento morrón, aceitunas y queso de cabra.'},
          'ensalada-silvestre': {name: 'Ensalada Silvestre', desc: 'Fresca combinación de lechuga, rúcula, berros, cebolla perla y jugosos gajos de naranjas.'},
          'ensalada-verde': {name: 'Ensalada Verde', desc: 'Liviana combinación de frescas hojas de lechuga, rúcula, palta, berros y espinacas.'},
        },
        'carnes': {
          'asado-de-tira-angus-600-grs': {name: 'Asado de Tira Angus 600 grs', desc: 'Exquisita costilla Angus, asada a la parrilla con sal de mar.'},
          'asado-de-tira-angus-800-grs': {name: 'Asado de Tira Angus 800 grs', desc: 'Exquisita costilla Angus, asada al horno en cocción lenta por 8 horas.'},
          'baby-beef-angus-450-grs': {name: 'Baby Beef Angus 450 grs', desc: 'Sabroso lomo vetado angus envuelto en tocino y asado a la parrilla.'},
          'bife-chorizo-wagyu-400-grs': {name: 'Bife Chorizo Wagyu 400 grs', desc: 'Exquisito Lomo Vetado de Wagyu de categoría Marmoleado N°7 asado a la parrilla. Carne tierna con grasa infiltrada que le aporta su característico y único sabor.'},
          'bife-chorizo-angus-400-grs': {name: 'Bife Chorizo Angus 400 grs', desc: 'Exquisito lomo liso Angus asado a la parrilla con capa de grasa que aporta gran sabor.'},
          'bife-relleno-solocarnes-400-grs': {name: 'Bife Relleno Solocarnes 400 grs', desc: 'Lomo liso asado con espinacas, tocino, tomate, pimiento morrón y queso parmesano.'},
          'cordero-de-bulnes-450-grs': {name: 'Cordero de Bulnes 450 grs', desc: 'Exquisitos cortes de cordero asados, marinados en vino blanco con romero y ajo, con puré.'},
          'entrana-300-grs': {name: 'Entraña 300 grs', desc: 'Corte de gran sabor y ternura, asado a la parrilla, condimentado con sal parrillera.'},
          'entrana-de-wagyu-400-grs': {name: 'Entraña de Wagyu 400 grs', desc: 'Corte Wagyu de gran sabor y ternura, asado a la parrilla con sal parrillera.'},
          'filete-aquarium-300-grs': {name: 'Filete Aquarium 300 grs', desc: 'Medallón de filete asado, relleno con camarones ecuatorianos sobre salsa de vino blanco.'},
          'filete-grille-300-grs': {name: 'Filete Grillé 300 grs', desc: 'Sabroso medallón de filete Angus asado a la parrilla con sal parrillera.'},
          'porterhouse-steak-700-grs': {name: 'Porterhouse Steak 700 grs', desc: 'Extraordinario corte que reúne lomo liso y filete, condimentado con sal marina.'},
          'plateada-al-horno': {name: 'Plateada al Horno', desc: 'Sabroso trozo de plateada horneado con verduras y vino blanco en reducción de jugos.'},
          'tomahawk-1-5-kgs': {name: 'Tomahawk 1.5 kgs', desc: 'Exquisita costeleta de Lomo Liso/Vetado a la parrilla sazonada con sal de mar.'},
        },
        'pescados': {
          'atun-del-ecuador': {name: 'Atún del Ecuador', desc: 'Exquisito atún ecuatoriano sellado a la parrilla con finas hierbas, merquén y sal.'},
          'congrio-dorado': {name: 'Congrio Dorado', desc: 'Sabroso congrio dorado preparado a la mantequilla, aromatizado con vino blanco.'},
          'corvina-con-camarones-salteados': {name: 'Corvina con Camarones Salteados', desc: 'Filete de corvina a la mantequilla con camarones ecuatorianos salteados al olivo.'},
          'corvina-grille': {name: 'Corvina Grillé', desc: 'Delicioso filete de corvina grillado a la mantequilla con vino blanco.'},
          'corvina-roulade': {name: 'Corvina Roulade', desc: 'Filete de corvina relleno con camarones, espárragos y alcaparras sobre salsa de vino blanco.'},
          'merluza-austral-grille': {name: 'Merluza Austral Grillé', desc: 'Exquisito filete de merluza austral grillado con vino blanco.'},
          'salmon-grille-con-camarones': {name: 'Salmón Grillé con Camarones', desc: 'Filete de salmón a la mantequilla con camarones ecuatorianos aromatizados con vino blanco.'},
          'salmon-grille': {name: 'Salmón Grillé', desc: 'Delicioso filete de salmón preparado a la mantequilla.'},
        },
        'pastas': {
          'canelones-con-centolla': {name: 'Canelones con Centolla', desc: 'Pasta rellena con Centolla, con salsa tres quesos gratinada con parmesano.'},
          'canelones-con-locos': {name: 'Canelones con Locos', desc: 'Pasta rellena con locos, con salsa de camarones ecuatorianos gratinada con parmesano.'},
          'canelones-con-pollo': {name: 'Canelones con Pollo', desc: 'Pasta rellena con pollo, con salsa tres quesos gratinada con parmesano.'},
          'espagueti': {name: 'Espagueti', desc: 'Exquisita pasta fresca, salteada a la mantequilla o al olivo.'},
          'espagueti-al-pesto': {name: 'Espagueti al Pesto', desc: 'Espaguetis salteados con pasta de albahaca, aceite de oliva, ajo y nueces.'},
          'lasana-bolonesa': {name: 'Lasaña Boloñesa', desc: 'Pasta en láminas con salsa boloñesa, tres quesos, mozzarella y parmesano gratinada.'},
          'noquis-bolonesa-18-unidades': {name: 'Ñoquis Boloñesa (18 unidades)', desc: 'Pasta de papas, harina y nuez moscada con salsa boloñesa.'},
          'pappardelle-fruto-di-mare': {name: 'Pappardelle Fruto di Mare', desc: 'Pasta de cinta salteada con mariscos, tomates, albahaca, orégano y crema fresca.'},
          'ravioles-con-espinacas': {name: 'Ravioles con Espinacas', desc: 'Pasta rellena con espinacas, queso parmesano y nuez moscada.'},
          'sorrentinos-de-centolla': {name: 'Sorrentinos de Centolla', desc: 'Pasta rellena con centolla, puerros, queso crema y parmesano con albahaca y tomates cherry.'},
        },
        'veganos': {
          'croquetas-de-lentejas-con-salsa-pomodoro': {name: 'Croquetas de Lentejas con Salsa Pomodoro', desc: 'Croquetas de lentejas apanadas en panko con salsa pomodoro y arroz blanco.'},
          'hamburguesa-de-garbanzos': {name: 'Hamburguesa de Garbanzos', desc: 'Hamburguesa de garbanzos y verduras con ensalada fresca y dressing de mostaza.'},
          'quinotto-de-champinones': {name: 'Quinotto de Champiñones', desc: 'Preparación de quinoa y caldo de verduras con cebollín fresco y almendras tostadas.'},
        },
        'celiacos': {
          'espirales-de-arroz-con-camarones': {name: 'Espirales de Arroz con Camarones', desc: 'Pasta de harina de arroz salteada con camarones, verduras, tomates, orégano y albahaca.'},
          'lomo-liso-con-papas-rusticas': {name: 'Lomo Liso con Papas Rústicas', desc: 'Filete de lomo liso a la parrilla con sal de mar, papas rústicas y zanahorias salteadas.'},
          'merluza-austral-con-verduras': {name: 'Merluza Austral con Verduras', desc: 'Filete de merluza austral a la parrilla con verduras y nueces salteadas al olivo.'},
        },
        'postres': {
          'churros-caseros': {name: 'Churros Caseros', desc: 'Suave masa frita con azúcar flor, acompañada con manjar y helado de vainilla.'},
          'creme-brulee': {name: 'Crème Brûlée', desc: 'Delicioso postre francés de crema fresca, yemas de huevo, vainilla y caramelo crujiente.'},
          'globo-de-chocolate': {name: 'Globo de Chocolate', desc: 'Delicada esfera de chocolate que esconde un postre en su interior.'},
          'helados-artesanales': {name: 'Helados Artesanales', desc: 'Deliciosos helados de elaboración propia.'},
          'leche-asada': {name: 'Leche Asada', desc: 'Fresco postre casero de huevos y leche aromatizada con naranja y vainilla.'},
          'panqueque-celestino': {name: 'Panqueque Celestino', desc: 'Panqueques rellenos con manjar, azúcar flor y helado de vainilla.'},
          'papayas-al-jugo': {name: 'Papayas al Jugo', desc: 'Jugosas papayas al jugo, acompañadas con crema espesa opcional.'},
          'picarones': {name: 'Picarones', desc: 'Tradicional postre chileno. Anillos de masa frita de zapallo con salsa de Chancaca.'},
          'suspiro-limeno': {name: 'Suspiro Limeño', desc: 'Postre peruano de leche condensada y evaporada, aromatizado con Oporto y merengue italiano.'},
          'tiramisu': {name: 'Tiramisú', desc: 'Postre italiano de queso crema, vainilla, vino añejo y café ristretto.'},
          'volcan-de-chocolate': {name: 'Volcán de Chocolate', desc: 'Bizcocho de chocolate con centro líquido, acompañado de helado de vainilla.'},
        },
        'salsas': {
          'salsa-4-pimientas': {name: 'Salsa 4 Pimientas', desc: 'Preparación en base a salsa blanca, selección de 4 pimientas y un toque de crema y coñac.'},
          'salsa-al-pesto': {name: 'Salsa al Pesto', desc: 'Preparación a base de albahaca, ajo, aceite de oliva y nueces.'},
          'salsa-alfredo': {name: 'Salsa Alfredo', desc: 'Preparación en base a salsa de tres quesos y trozos de jamón.'},
          'salsa-arrabiata': {name: 'Salsa Arrabiata', desc: 'Preparación en base a salsa de tomates, tocino ahumado, alcaparras y un toque de ajo, albahaca y merquén.'},
          'salsa-bolonesa': {name: 'Salsa Boloñesa', desc: 'Preparación elaborada en base a salsa de tomates, carne picada y verduras.'},
          'salsa-de-centolla': {name: 'Salsa de Centolla', desc: 'Suave salsa elaborada con carne de centolla, crema fresca y un toque de orégano.'},
          'salsa-de-locos': {name: 'Salsa de Locos', desc: 'Deliciosa salsa elaborada con trozos de locos, crema fresca y un toque de orégano.'},
          'salsa-de-mostaza': {name: 'Salsa de Mostaza', desc: 'Preparación en base a mostaza Dijon, crema fresca y un toque de pimienta.'},
          'salsa-de-pulpo': {name: 'Salsa de Pulpo', desc: 'Sabrosa salsa elaborada con trozos de pulpo.'},
          'salsa-pomodoro': {name: 'Salsa Pomodoro', desc: 'Sabrosa preparación en base a salsa de tomates, cebollas, aceitunas y orégano.'},
        },
        'tablas': {
          'tabla-aquarium-4-locos': {name: 'Tabla Aquarium 4 Locos', desc: 'Compuesta de Locos, Pulpo a la Parrilla, Camarones al olivo y Machas a la parmesana.'},
          'tabla-aquarium-premium': {name: 'Tabla Aquarium Premium', desc: '8 Locos, Pulpo a la parrilla, Centolla desmenuzada, Camarones al Olivo y machas a la parmesana.'},
          'tabla-de-carnes-y-guacamole': {name: 'Tabla de Carnes y Guacamole', desc: 'Pollo, Lomo de Res y Lomo de Cerdo salteados con champiñones y guacamole.'},
          'tabla-mixta-solocarnes': {name: 'Tabla Mixta Solocarnes', desc: 'Mix de carnes, mariscos y verduras: lomo, pollo, camarones panko, calamares con ensalada fresca.'},
        },
        'vinos': {
          // COPAS DE VINO
          'copa-arboleda-chardonnay': {name: 'Copa Arboleda Chardonnay', desc: '', price: '$9.500'},
          'copa-san-pedro-1865-sauvignon-blanc': {name: 'Copa San Pedro 1865 Sauvignon Blanc', desc: '', price: '$7.500'},
          'copa-montes-alpha-carmenere': {name: 'Copa Montes Alpha Carmenere/Cabernet Sauvignon/Merlot', desc: '', price: '$9.500'},
          'copa-max-errazuriz': {name: 'Copa Max Viña Errazuriz Carmenere/Cabernet Sauvignon/Chardonnay', desc: '', price: '$7.500'},
          
          // CHARDONNAY
          'arboleda-chardonnay': {name: 'Arboleda Chardonnay Premium', desc: '', price: '$38.000'},
          'caliterra-chardonnay': {name: 'Caliterra Chardonnay Reserva', desc: '', price: '$15.000'},
          'casa-silva-chardonnay': {name: 'Casa Silva Cuvée Colchagua Chardonnay Reserva', desc: '', price: '$18.000'},
          'concha-y-toro-chardonnay': {name: 'Concha y Toro Marques de Casa Concha Chardonnay Premium', desc: '', price: '$33.000'},
          'errazuriz-max-chardonnay': {name: 'Errázuriz Max Reserva Chardonnay Premium', desc: '', price: '$31.000'},
          'montes-alpha-chardonnay': {name: 'Montes Alpha Chardonnay Premium', desc: '', price: '$38.000'},
          'san-pedro-castillo-chardonnay': {name: 'San Pedro Castillo de Molina Chardonnay Reserva', desc: '', price: '$18.000'},
          'tarapaca-chardonnay': {name: 'Tarapacá Chardonnay Gran Reserva', desc: '', price: '$24.000'},
          'terranoble-chardonnay': {name: 'Terranoble Chardonnay Gran Reserva', desc: '', price: '$27.000'},
          
          // SAUVIGNON BLANC
          'arboleda-sauvignon-blanc': {name: 'Arboleda Sauvignon Blanc Premium', desc: '', price: '$38.000'},
          'casa-silva-sauvignon-blanc': {name: 'Casa Silva Cuvée Colchagua Sauvignon Blanc Reserva', desc: '', price: '$18.000'},
          'errazuriz-max-sauvignon-blanc': {name: 'Errázuriz Max Reserva Sauvignon Blanc Premium', desc: '', price: '$31.000'},
          'san-pedro-1865-sauvignon-blanc': {name: 'San Pedro 1865 Sauvignon Blanc Premium', desc: '', price: '$30.000'},
          'san-pedro-castillo-sauvignon-blanc': {name: 'San Pedro Castillo de Molina Sauvignon Blanc Reserva', desc: '', price: '$18.000'},
          'santa-cruz-chaman-sauvignon-blanc': {name: 'Santa Cruz Chamán Sauvignon Blanc Reserva', desc: '', price: '$27.000'},
          'tarapaca-sauvignon-blanc': {name: 'Tarapacá Sauvignon Blanc Gran Reserva', desc: '', price: '$24.000'},
          
          // CARMENERE
          'arboleda-carmenere': {name: 'Arboleda Carmenere Premium', desc: '', price: '$38.000'},
          'caliterra-tributo-carmenere': {name: 'Caliterra Tributo Carmenere Gran Reserva', desc: '', price: '$21.000'},
          'caliterra-carmenere': {name: 'Caliterra Carmenere Reserva', desc: '', price: '$15.000'},
          'casa-silva-carmenere': {name: 'Casa Silva Gran Terroir de los Andes Carmenere Gran Reserva', desc: '', price: '$28.000'},
          'concha-y-toro-carmenere': {name: 'Concha y Toro Marques de Casa Concha Carmenere Premium', desc: '', price: '$33.000'},
          'errazuriz-max-carmenere': {name: 'Errázuriz Max Reserva Carmenere Premium', desc: '', price: '$31.000'},
          'montes-alpha-carmenere': {name: 'Montes Alpha Carmenere Premium', desc: '', price: '$38.000'},
          'perez-cruz-carmenere': {name: 'Perez Cruz Carmenere Limited Edition', desc: '', price: '$40.000'},
          'san-pedro-1865-carmenere': {name: 'San Pedro 1865 Carmenere Premium', desc: '', price: '$30.000'},
          'san-pedro-castillo-carmenere': {name: 'San Pedro Castillo de Molina Carmenere Reserva', desc: '', price: '$18.000'},
          'santa-cruz-chaman-carmenere': {name: 'Santa Cruz Chamán Carmenere Gran Reserva', desc: '', price: '$27.000'},
          'santa-ema-carmenere': {name: 'Santa Ema Carmenere Gran Reserva', desc: '', price: '$22.000'},
          'terranoble-carmenere': {name: 'Terranoble Carmenere Gran Reserva', desc: '', price: '$27.000'},
          
          // CABERNET SAUVIGNON
          'arboleda-cabernet-sauvignon': {name: 'Arboleda Cabernet Sauvignon Premium', desc: '', price: '$38.000'},
          'caliterra-tributo-cabernet': {name: 'Caliterra Tributo Cabernet Sauvignon Gran Reserva', desc: '', price: '$21.000'},
          'caliterra-cabernet': {name: 'Caliterra Cabernet Sauvignon Reserva', desc: '', price: '$15.000'},
          'casa-silva-cabernet': {name: 'Casa Silva Gran Terroir de los Andes Cabernet Sauvignon Gran Reserva', desc: '', price: '$28.000'},
          'concha-y-toro-cabernet': {name: 'Concha y Toro Marques de Casa Concha Cabernet Sauvignon Premium', desc: '', price: '$33.000'},
          'errazuriz-max-cabernet': {name: 'Errázuriz Max Reserva Cabernet Sauvignon Premium', desc: '', price: '$31.000'},
          'montes-alpha-cabernet': {name: 'Montes Alpha Cabernet Sauvignon Premium', desc: '', price: '$38.000'},
          'perez-cruz-cabernet-piedra-seca': {name: 'Perez Cruz Cabernet Sauvignon Piedra Seca', desc: '', price: '$50.000'},
          'perez-cruz-cabernet-gran-reserva': {name: 'Perez Cruz Cabernet Sauvignon Gran Reserva', desc: '', price: '$23.000'},
          'san-pedro-1865-cabernet': {name: 'San Pedro 1865 Cabernet Sauvignon Premium', desc: '', price: '$30.000'},
          'san-pedro-castillo-cabernet': {name: 'San Pedro Castillo de Molina Cabernet Sauvignon Reserva', desc: '', price: '$18.000'},
          'santa-ema-cabernet': {name: 'Santa Ema Cabernet Sauvignon Gran Reserva', desc: '', price: '$22.000'},
          'tarapaca-etiqueta-negra': {name: 'Tarapacá Etiqueta Negra Cabernet Sauvignon Gran Reserva', desc: '', price: '$38.000'},
          'tarapaca-cabernet': {name: 'Tarapacá Cabernet Sauvignon Gran Reserva', desc: '', price: '$24.000'},
          'terranoble-cabernet': {name: 'Terranoble Cabernet Sauvignon Gran Reserva', desc: '', price: '$27.000'},
          
          // MERLOT
          'caliterra-merlot': {name: 'Caliterra Merlot Reserva', desc: '', price: '$15.000'},
          'concha-y-toro-merlot': {name: 'Concha y Toro Marques de Casa Concha Merlot Premium', desc: '', price: '$33.000'},
          'montes-alpha-merlot': {name: 'Montes Alpha Merlot Premium', desc: '', price: '$38.000'},
          'san-pedro-1865-merlot': {name: 'San Pedro 1865 Merlot Premium', desc: '', price: '$30.000'},
          'santa-ema-merlot': {name: 'Santa Ema Merlot Gran Reserva', desc: '', price: '$22.000'},
          
          // PINOT NOIR
          'arboleda-pinot-noir': {name: 'Arboleda Pinot Noir Premium', desc: '', price: '$38.000'},
          'montes-alpha-pinot-noir': {name: 'Montes Alpha Pinot Noir Premium', desc: '', price: '$38.000'},
          
          // MALBEC
          'caliterra-tributo-malbec': {name: 'Caliterra Tributo Malbec Gran Reserva', desc: '', price: '$21.000'},
          'errazuriz-max-malbec': {name: 'Errázuriz Max Reserva Malbec Premium', desc: '', price: '$31.000'},
          'montes-alpha-malbec': {name: 'Montes Alpha Malbec Premium', desc: '', price: '$38.000'},
          'santa-cruz-chaman-malbec': {name: 'Santa Cruz Chamán Malbec Gran Reserva', desc: '', price: '$27.000'},
          
          // SYRAH
          'arboleda-syrah': {name: 'Arboleda Syrah Premium', desc: '', price: '$38.000'},
          'caliterra-tributo-syrah': {name: 'Caliterra Tributo Syrah Gran Reserva', desc: '', price: '$21.000'},
          'montes-alpha-syrah': {name: 'Montes Alpha Syrah Premium', desc: '', price: '$38.000'},
          
          // MEZCLAS
          'casa-silva-quinta-generacion': {name: 'Casa Silva Quinta Generación Premium (Cabernet Sauvignon, Carmenere, Syrah, Petit Verdot)', desc: '', price: '$52.000'},
          'montgras-quatro': {name: 'Montgras Quatro Gran Reserva (Cabernet Sauvignon, Syrah, Carmenere, Malbec)', desc: '', price: '$30.000'},
          'santa-cruz-tupu': {name: 'Santa Cruz Tupu Super Premium (Cabernet Sauvignon, Petit Verdot)', desc: '', price: '$57.000'},
          'santa-ema-barrel-reserve': {name: 'Santa Ema Barrel Reserve Gran Reserva (Cabernet Sauvignon, Merlot)', desc: '', price: '$23.000'},
          'santa-ema-catalina': {name: 'Santa Ema Catalina Super Premium (Cabernet Sauvignon, Carmenere, Cabernet Franc)', desc: '', price: '$70.000'},
          'tarapaca-etiqueta-azul': {name: 'Tarapacá Gran Reserva Etiqueta Azul Super Premium (Cabernet Sauvignon, Petit Verdot, Merlot, Cabernet Franc, Malbec)', desc: '', price: '$85.000'},
          'tarapaca-late-harvest': {name: 'Tarapacá Late Harvest 500cc (Sauvignon Blanc, Gewürztraminer, Riesling)', desc: '', price: '$12.000'},
          
          // VINOS ITALIANOS
          'cantine-ceci-lambrusco': {name: 'Cantine Ceci Lambrusco Amabile Giuseppe Verdi', desc: '', price: '$35.000'},
          
          // PREMIUM Y SUPER PREMIUM
          'casa-lapostolle-clos-apalta': {name: 'Casa Lapostolle Clos Apalta 2017 Ícono (Carmenere, Cabernet Sauvignon, Merlot, Petit Verdot)', desc: '', price: '$390.000'},
          'concha-y-toro-don-melchor': {name: 'Concha y Toro Don Melchor Ícono (Cabernet Sauvignon)', desc: '', price: '$600.000'},
          'errazuriz-don-maximiano': {name: 'Errázuriz Don Maximiano Founder\'s Reserve Ícono (Cabernet Sauvignon, Carmenere, Malbec, Petit Verdot)', desc: '', price: '$230.000'},
          'miguel-torres-manso-de-velasco': {name: 'Miguel Torres Manso de Velasco Ícono (Cabernet Sauvignon)', desc: '', price: '$150.000'},
          'montes-alpha-m': {name: 'Montes Alpha M Ícono (Cabernet Sauvignon, Cabernet Franc, Merlot, Petit Verdot)', desc: '', price: '$290.000'},
          'sena': {name: 'Seña Ícono (Cabernet Sauvignon, Carmenere, Malbec, Merlot, Petit Verdot)', desc: '', price: '$400.000'},
          'montes-purple-angel': {name: 'Montes Purple Angel Carmenere (Cabernet Sauvignon, Carmenere, Cabernet Franc, Syrah, Malbec, Carignan, Petit Verdot, Merlot)', desc: '', price: '$290.000'},
          'vinedo-chadwick': {name: 'Viñedo Chadwick Super Premium (Cabernet Sauvignon)', desc: '', price: '$700.000'},
        },
        'cervezas': {
          // CERVEZAS REGULARES
          'austral-calafate': {name: 'Austral Calafate', desc: '', price: '$4.000'},
          'austral-lager': {name: 'Austral Lager', desc: '', price: '$4.000'},
          'budweiser': {name: 'Budweiser', desc: '', price: '$4.000'},
          'corona-extra': {name: 'Corona Extra', desc: '', price: '$4.000'},
          'erdinger-weissbier': {name: 'Erdinger Weissbier', desc: '', price: '$5.000'},
          'heineken': {name: 'Heineken', desc: '', price: '$4.000'},
          'kross-golden-pale-ale': {name: 'Kross Golden Pale Ale', desc: '', price: '$6.000'},
          'kunstmann-lager': {name: 'Kunstmann Lager', desc: '', price: '$4.000'},
          'kunstmann-torobayo-330': {name: 'Kunstmann Torobayo 330cc', desc: '', price: '$4.000'},
          'kunstmann-torobayo-500': {name: 'Kunstmann Torobayo 500cc', desc: '', price: '$6.000'},
          'kunstmann-gran-torobayo': {name: 'Kunstmann Gran Torobayo 500cc', desc: '', price: '$7.000'},
          'kunstmann-bock': {name: 'Kunstmann Bock', desc: '', price: '$4.000'},
          'kunstmann-miel': {name: 'Kunstmann Miel', desc: '', price: '$4.000'},
          
          // CERVEZAS BELGAS
          'delirium-christmas': {name: 'Delirium Christmas', desc: '', price: '$9.500'},
          'delirium-nocturnum': {name: 'Delirium Nocturnum', desc: '', price: '$9.500'},
          'delirium-tremens': {name: 'Delirium Tremens', desc: '', price: '$9.500'},
          
          // CERVEZAS SIN ALCOHOL
          'erdinger-alkoholfrei': {name: 'Erdinger Alkoholfrei', desc: '', price: '$5.000'},
          'grolsch-non-alcoholic': {name: 'Grolsch Non-Alcoholic 0,0%', desc: '', price: '$4.000'},
          'heineken-sin-alcohol': {name: 'Heineken Sin Alcohol', desc: '', price: '$4.000'},
          'kunstmann-sin-alcohol': {name: 'Kunstmann Sin Alcohol', desc: '', price: '$4.000'},
        },
        'cocteleria': {
          // COCKTAILS CLÁSICOS
          'bitter-a-la-francesa': {name: 'Bitter a la Francesa', desc: '', price: '$6.000'},
          'jugo-tomates-alinos': {name: 'Jugo de Tomates con Aliños', desc: '', price: '$5.000'},
          'sangria-en-jerez': {name: 'Sangría en Jerez', desc: '', price: '$5.000'},
          
          // === GIN ===
          'beefeater-dry': {
            name: 'Beefeater London Dry Gin',
            desc: '',
            priceShot: '$6.000',
            priceCombinado: '$7.000'
          },
          'beefeater-pink': {
            name: 'Beefeater London Pink Gin',
            desc: '',
            priceShot: '$6.500',
            priceCombinado: '$7.500'
          },
          'bombay-sapphire': {
            name: 'Bombay Sapphire London Dry Gin',
            desc: '',
            priceShot: '$5.500',
            priceCombinado: '$6.500'
          },
          'bulldog': {
            name: 'Bulldog London Dry Gin',
            desc: '',
            priceShot: '$8.000',
            priceCombinado: '$9.000'
          },
          'hendricks': {
            name: 'Hendrick\'s Gin',
            desc: '',
            priceShot: '$11.000',
            priceCombinado: '$12.000'
          },
          'hendricks-lunar': {
            name: 'Hendrick\'s Lunar Gin',
            desc: '',
            priceShot: '$11.000',
            priceCombinado: '$12.000'
          },
          'mombasa-club': {
            name: 'Mombasa Club Gin',
            desc: '',
            priceShot: '$14.000',
            priceCombinado: '$15.000'
          },
          'mombasa-strawberry': {
            name: 'Mombasa Club Gin Strawberry Edition',
            desc: '',
            priceShot: '$14.000',
            priceCombinado: '$15.000'
          },
          'tanqueray': {
            name: 'Tanqueray London Dry Gin',
            desc: '',
            priceShot: '$6.500',
            priceCombinado: '$7.500'
          },
          'tanqueray-ten': {
            name: 'Tanqueray Batch Distilled Gin Nº TEN',
            desc: '',
            priceShot: '$14.000',
            priceCombinado: '$15.000'
          },
          'london-no1': {
            name: 'The London Nº1 Blue Gin',
            desc: '',
            priceShot: '$13.000',
            priceCombinado: '$14.000'
          },

          // === BRANDY ===
          'agustin-blazquez': {
            name: 'Agustín Blázquez Felipe II',
            desc: '',
            priceShot: '$8.000'
          },
          'carlos-i': {
            name: 'Carlos I Solera Gran Reserva',
            desc: '',
            priceShot: '$22.000'
          },
          'lepanto': {
            name: 'Lepanto Solera Gran Reserva',
            desc: '',
            priceShot: '$20.000'
          },
          'torres-10': {
            name: 'Torres 10 Imperial Brandy',
            desc: '',
            priceShot: '$10.000'
          },
          'torres-20': {
            name: 'Torres Imperial Brandy 20 Años',
            desc: '',
            priceShot: '$13.000'
          },

          // === COGNAC ===
          'camus-xo': {
            name: 'Camus X.O. Elegance Cognac',
            desc: '',
            priceShot: '$43.000'
          },
          'courvoisier-xo': {
            name: 'Courvoisier X.O. Cognac',
            desc: '',
            priceShot: '$48.000'
          },
          'hennessy-vs': {
            name: 'Hennessy V.S. Cognac',
            desc: '',
            priceShot: '$20.000'
          },
          'hennessy-vsop': {
            name: 'Hennessy V.S.O.P. Cognac',
            desc: '',
            priceShot: '$37.000'
          },
          'hennessy-xo': {
            name: 'Hennessy X.O. Cognac',
            desc: '',
            priceShot: '$80.000'
          },
          'martell-xo': {
            name: 'Martell X.O. Extra Old Cognac',
            desc: '',
            priceShot: '$85.000'
          },
          'remy-martin-vsop': {
            name: 'Rémy Martin V.S.O.P. Cognac Fine Champagne',
            desc: '',
            priceShot: '$23.000'
          },
          'remy-martin-xo': {
            name: 'Rémy Martin X.O. Cognac Fine Champagne',
            desc: '',
            priceShot: '$80.000'
          },

          // === OPORTO / JERÉZ ===
          'osborne-tawny': {
            name: 'Osborne Fine Tawny Oporto Frutal',
            desc: '',
            priceShot: '$10.000'
          },
          'osborne-fino-quinta': {
            name: 'Osborne Fino Quinta',
            desc: '',
            priceShot: '$6.000'
          },
          'osborne-oporto-10': {
            name: 'Osborne Oporto 10 Years Old Tawny',
            desc: '',
            priceShot: '$14.000'
          },
          'tio-pepe': {
            name: 'Tío Pepe Jerez Palomino Fino',
            desc: '',
            priceShot: '$6.000'
          },
          'zalamero': {
            name: 'Zalamero Jerez Centenario',
            desc: '',
            priceShot: '$5.000'
          },

          // === BAJATIVOS ===
          'amarula': {
            name: 'Amarula Licor de Marula',
            desc: '',
            price: '$7.000'
          },
          'baileys': {
            name: 'Baileys Irish Cream',
            desc: '',
            price: '$6.500'
          },
          'cointreau': {
            name: 'Cointreau',
            desc: '',
            price: '$12.000'
          },
          'licor-43': {
            name: 'Diego Zamora Licor 43',
            desc: '',
            price: '$8.000'
          },
          'disaronno': {
            name: 'Disaronno Amaretto',
            desc: '',
            price: '$8.500'
          },
          'drambuie': {
            name: 'Drambuie',
            desc: '',
            price: '$8.000'
          },
          'frangelico': {
            name: 'Frangelico',
            desc: '',
            price: '$6.500'
          },
          'fernet-branca': {
            name: 'Fernet Branca',
            desc: '',
            price: '$5.500'
          },
          'fernet-rossard': {
            name: 'Fernet Rossard',
            desc: '',
            price: '$5.000'
          },
          'grand-marnier': {
            name: 'Grand Marnier',
            desc: '',
            price: '$15.000'
          },
          'jagermeister': {
            name: 'Jägermeister',
            desc: '',
            price: '$5.000'
          },
          'kahlua': {
            name: 'Kahlúa Licor de Café',
            desc: '',
            price: '$6.500'
          },
          'licor-araucano': {
            name: 'Licor Araucano',
            desc: '',
            price: '$6.000'
          },
          'limoncello': {
            name: 'Luxardo Limoncello Liqueur',
            desc: '',
            price: '$11.000'
          },
          'sambuca': {
            name: 'Luxardo Sambuca del Cesari',
            desc: '',
            price: '$9.000'
          },
          'menthe-verte': {
            name: 'Marie Brizard Menthe Verte Nº32',
            desc: '',
            price: '$6.000'
          },
          'ouzo': {
            name: 'Ouzo Athenée Licor de Anís',
            desc: '',
            price: '$5.000'
          },
          'pernord': {
            name: 'Pernord',
            desc: '',
            price: '$5.000'
          },
          'saint-germain': {
            name: 'Saint Germain Elderflower Liqueur',
            desc: '',
            price: '$9.500'
          },
          'sheridans': {
            name: 'Sheridan\'s Licor de Café',
            desc: '',
            price: '$11.000'
          },

          // === PISCOS ===
          'alto-carmen-especial': {
            name: 'Alto del Carmen Especial 35°',
            desc: '',
            priceShot: '$4.000',
            priceCombinado: '$5.000'
          },
          'alto-carmen-reservado': {
            name: 'Alto del Carmen Reservado 40°',
            desc: '',
            priceShot: '$5.000',
            priceCombinado: '$6.000'
          },
          'alto-carmen-transparente': {
            name: 'Alto del Carmen Transparente 40°',
            desc: '',
            priceShot: '$5.000',
            priceCombinado: '$6.000'
          },
          'alto-carmen-cumbre': {
            name: 'Alto del Carmen Cumbre 40°',
            desc: '',
            priceShot: '$8.000',
            priceCombinado: '$9.000'
          },
          'black-heron': {
            name: 'Black Heron Triple Destilado 43,5°',
            desc: '',
            priceShot: '$7.000',
            priceCombinado: '$8.000'
          },
          'capel': {
            name: 'Capel Doble Destilado 35°',
            desc: '',
            priceShot: '$4.000',
            priceCombinado: '$5.000'
          },
          'horcon-especial': {
            name: 'Horcon Quemado Especial Añejado 1 Año 35°',
            desc: '',
            priceShot: '$5.000',
            priceCombinado: '$6.000'
          },
          'horcon-reservado': {
            name: 'Horcon Quemado Reservado Añejado 2 Años 40°',
            desc: '',
            priceShot: '$7.000',
            priceCombinado: '$8.000'
          },
          'kappa': {
            name: 'Kappa Reservado 40°',
            desc: '',
            priceShot: '$13.000',
            priceCombinado: '$14.000'
          },
          'mistral-35': {
            name: 'Mistral Añejado en Roble 35°',
            desc: '',
            priceShot: '$4.000',
            priceCombinado: '$5.000'
          },
          'mistral-40': {
            name: 'Mistral Añejado en Roble 40°',
            desc: '',
            priceShot: '$5.000',
            priceCombinado: '$6.000'
          },
          'mistral-nobel-fire': {
            name: 'Mistral Nobel Fire 30°',
            desc: '',
            priceShot: '$5.000',
            priceCombinado: '$6.000'
          },
          'mistral-nobel-reservado': {
            name: 'Mistral Reservado Nobel 40°',
            desc: '',
            priceShot: '$5.000',
            priceCombinado: '$6.000'
          },
          'mistral-nobel-barrica': {
            name: 'Mistral Reservado Nobel Barrica Tostada 40°',
            desc: '',
            priceShot: '$5.000',
            priceCombinado: '$6.000'
          },
          'mistral-gran-nobel': {
            name: 'Mistral Reserva Privada Gran Nobel 40°',
            desc: '',
            priceShot: '$10.000',
            priceCombinado: '$11.000'
          },
          'republicano-40': {
            name: 'Republicano Añejado en Roble 40°',
            desc: '',
            priceShot: '$5.000',
            priceCombinado: '$6.000'
          },
          'republicano-triple': {
            name: 'Republicano Triple Destilado 40°',
            desc: '',
            priceShot: '$5.000',
            priceCombinado: '$6.000'
          },
          'waqar': {
            name: 'Waqar Pisco D.O. 40°',
            desc: '',
            priceShot: '$12.000',
            priceCombinado: '$13.000'
          },

          // === RON ===
          'bacardi-blanca': {
            name: 'Bacardí Carta Blanca',
            desc: '',
            priceShot: '$4.000',
            priceCombinado: '$5.000'
          },
          'bacardi-8': {
            name: 'Bacardí Ron Gran Reserva 8 Años',
            desc: '',
            priceShot: '$6.000',
            priceCombinado: '$7.000'
          },
          'casa-bacardi': {
            name: 'Casa Bacardí Reserva Especial',
            desc: '',
            priceShot: '$17.000',
            priceCombinado: '$18.000'
          },
          'havana-7': {
            name: 'Havana Club Añejo 7 años',
            desc: '',
            priceShot: '$8.000',
            priceCombinado: '$9.000'
          },
          'matusalem': {
            name: 'Matusalem Ron Solera 7 Años',
            desc: '',
            priceShot: '$6.000',
            priceCombinado: '$7.000'
          },
          'pampero': {
            name: 'Pampero Ron Extra Añejo Aniversario',
            desc: '',
            priceShot: '$14.000',
            priceCombinado: '$15.000'
          },
          'zacapa-12': {
            name: 'Zacapa Ron Centenario Ambar 12 Años',
            desc: '',
            priceShot: '$14.000',
            priceCombinado: '$15.000'
          },
          'zacapa-23': {
            name: 'Zacapa Ron Centenario 23 Años',
            desc: '',
            priceShot: '$24.000',
            priceCombinado: '$25.000'
          },
          'zacapa-xo': {
            name: 'Zacapa Centenario X.O. Solera Gran Reserva',
            desc: '',
            priceShot: '$55.000',
            priceCombinado: '$56.000'
          },

          // === TEQUILA ===
          '1800-silver': {
            name: '1800 Silver',
            desc: '',
            priceShot: '$13.000'
          },
          '1800-reposado': {
            name: '1800 Reposado',
            desc: '',
            priceShot: '$13.000'
          },
          'don-julio': {
            name: 'Don Julio Reposado',
            desc: '',
            priceShot: '$24.000'
          },
          'herradura': {
            name: 'Herradura Reposado',
            desc: '',
            priceShot: '$14.000'
          },
          'jose-cuervo-silver': {
            name: 'José Cuervo Silver',
            desc: '',
            priceShot: '$6.000'
          },
          'jose-cuervo-reposado': {
            name: 'José Cuervo Reposado',
            desc: '',
            priceShot: '$10.000'
          },
          'patron-anejo': {
            name: 'Patron Tequila Añejo',
            desc: '',
            priceShot: '$20.000'
          },

          // === CACHAZA ===
          'cachaca-51': {
            name: 'Cachaça 51',
            desc: '',
            priceShot: '$2.000'
          },
          'velho-barreiro': {
            name: 'Velho Barreiro',
            desc: '',
            priceShot: '$2.000'
          },

          // === VODKA ===
          'absolut-blue': {
            name: 'Absolut Original (Blue)',
            desc: '',
            priceShot: '$5.500',
            priceCombinado: '$6.500'
          },
          'absolut-sabores': {
            name: 'Absolut Citron/Kurant/Pears/Peppar/Raspberri',
            desc: '',
            priceShot: '$5.500',
            priceCombinado: '$6.500'
          },
          'absolut-elyx': {
            name: 'Absolut Elyx',
            desc: '',
            priceShot: '$12.500',
            priceCombinado: '$13.500'
          },
          'grey-goose': {
            name: 'Grey Goose',
            desc: '',
            priceShot: '$11.000',
            priceCombinado: '$12.000'
          },
          'grey-goose-sabores': {
            name: 'Grey Goose La Poire/L\'Orange',
            desc: '',
            priceShot: '$11.000',
            priceCombinado: '$12.000'
          },
          'grey-goose-vx': {
            name: 'Grey Goose VX (Vodka 95% + Cognac 5%)',
            desc: '',
            priceShot: '$39.000',
            priceCombinado: '$40.000'
          },
          'stolichnaya': {
            name: 'Stolichnaya',
            desc: '',
            priceShot: '$4.000',
            priceCombinado: '$5.000'
          },
          'stolichnaya-vainilla': {
            name: 'Stolichnaya Vainilla',
            desc: '',
            priceShot: '$4.000',
            priceCombinado: '$5.000'
          },
          'stolichnaya-elit': {
            name: 'Stolichnaya Elit Ultra Luxury Vodka',
            desc: '',
            priceShot: '$13.000',
            priceCombinado: '$14.000'
          },

          // === WHISKY ===
          'chivas-12': {
            name: 'Chivas Regal 12 Años',
            desc: '',
            priceShot: '$10.000',
            priceCombinado: '$11.000'
          },
          'chivas-18': {
            name: 'Chivas Regal Gold Signature 18 Años',
            desc: '',
            priceShot: '$24.000',
            priceCombinado: '$25.000'
          },
          'chivas-21': {
            name: 'Chivas Regal Royal Salute 21 Años',
            desc: '',
            priceShot: '$74.000',
            priceCombinado: '$75.000'
          },
          'glenfiddich-12': {
            name: 'Glenfiddich 12 Años',
            desc: '',
            priceShot: '$16.000',
            priceCombinado: '$17.000'
          },
          'glenfiddich-15': {
            name: 'Glenfiddich 15 Años',
            desc: '',
            priceShot: '$39.000',
            priceCombinado: '$40.000'
          },
          'jack-gentleman': {
            name: 'Jack Daniel\'s Gentleman Jack',
            desc: '',
            priceShot: '$16.000',
            priceCombinado: '$17.000'
          },
          'jack-sinatra': {
            name: 'Jack Daniel\'s Sinatra Select',
            desc: '',
            priceShot: '$45.000',
            priceCombinado: '$46.000'
          },
          'jack-single-barrel': {
            name: 'Jack Daniel\'s Single Barrel Select',
            desc: '',
            priceShot: '$19.000',
            priceCombinado: '$20.000'
          },
          'jack-no7': {
            name: 'Jack Daniel\'s Old Nº7',
            desc: '',
            priceShot: '$9.000',
            priceCombinado: '$10.000'
          },
          'jack-apple': {
            name: 'Jack Daniel\'s Tennessee Apple',
            desc: '',
            priceShot: '$9.000',
            priceCombinado: '$10.000'
          },
          'jack-fire': {
            name: 'Jack Daniel\'s Tennessee Fire',
            desc: '',
            priceShot: '$9.000',
            priceCombinado: '$10.000'
          },
          'jack-honey': {
            name: 'Jack Daniel\'s Tennessee Honey',
            desc: '',
            priceShot: '$9.000',
            priceCombinado: '$10.000'
          },
          'jameson': {
            name: 'Jameson Irish Whiskey',
            desc: '',
            priceShot: '$8.000',
            priceCombinado: '$9.000'
          },
          'jw-red': {
            name: 'Johnnie Walker Red Label',
            desc: '',
            priceShot: '$6.000',
            priceCombinado: '$7.000'
          },
          'jw-black': {
            name: 'Johnnie Walker Black Label 12 Años',
            desc: '',
            priceShot: '$10.000',
            priceCombinado: '$11.000'
          },
          'jw-double-black': {
            name: 'Johnnie Walker Double Black',
            desc: '',
            priceShot: '$17.000',
            priceCombinado: '$18.000'
          },
          'jw-gold': {
            name: 'Johnnie Walker Gold Label',
            desc: '',
            priceShot: '$29.000',
            priceCombinado: '$30.000'
          },
          'jw-swing': {
            name: 'Johnnie Walker Swing',
            desc: '',
            priceShot: '$24.000',
            priceCombinado: '$25.000'
          },
          'jw-blue': {
            name: 'Johnnie Walker Blue Label 21 Años',
            desc: '',
            priceShot: '$79.000',
            priceCombinado: '$80.000'
          },
          'dalmore-12': {
            name: 'The Dalmore 12 Años',
            desc: '',
            priceShot: '$29.000',
            priceCombinado: '$30.000'
          },
          'dalmore-15': {
            name: 'The Dalmore 15 Años',
            desc: '',
            priceShot: '$49.000',
            priceCombinado: '$50.000'
          },
          'glenlivet-founders': {
            name: 'The Glenlivet Founder\'s Reserve Est. 1824',
            desc: '',
            priceShot: '$13.000',
            priceCombinado: '$14.000'
          },
          'glenlivet-12': {
            name: 'The Glenlivet 12 Years Double Oak',
            desc: '',
            priceShot: '$15.000',
            priceCombinado: '$16.000'
          },
          'macallan-12': {
            name: 'The Macallan Double Cask 12 Años',
            desc: '',
            priceShot: '$44.000',
            priceCombinado: '$45.000'
          },
          'macallan-classic': {
            name: 'The Macallan Classic Cut',
            desc: '',
            priceShot: '$69.000',
            priceCombinado: '$70.000'
          },
          'grants-blended-scotch': {
            name:'Grants Blended Scotch 12 años',
            desc:'',
            priceShot: '$12.000',
            priceCombinado: '$13.000'
          },
          

          // === SPRITZ (Licor + Espumante Brut) ===
          'spritz-aperol': {
            name: 'Aperol Spritz',
            desc: 'Licor + Espumante Brut',
            price: '$8.000'
          },
          'spritz-chambord': {
            name: 'Chambord Spritz',
            desc: 'Licor + Espumante Brut',
            price: '$10.000'
          },
          'spritz-kir-royal': {
            name: 'Kir Royal Spritz',
            desc: 'Licor + Espumante Brut',
            price: '$6.000'
          },
          'spritz-limoncello': {
            name: 'Limoncello Spritz',
            desc: 'Licor + Espumante Brut',
            price: '$11.000'
          },
          'spritz-ramazzotti': {
            name: 'Ramazzotti Spritz',
            desc: 'Licor + Espumante Brut',
            price: '$9.000'
          },
          'spritz-saint-germain': {
            name: 'Saint Germain Spritz',
            desc: 'Licor + Espumante Brut',
            price: '$12.000'
          },

          // === SOUR'S ===
          'pisco-sour': {
            name: 'Pisco Sour',
            desc: '',
            price: '$7.000'
          },
          'pisco-sour-doble': {
            name: 'Pisco Sour Doble',
            desc: '',
            price: '$14.000'
          },
          'pisco-sour-sabores': {
            name: 'Pisco Sour Sabores',
            desc: 'Maracuyá / Mango / Chirimoya',
            price: '$7.000'
          },
          'pisco-sour-rica-rica': {
            name: 'Pisco Sour al Rica Rica',
            desc: '',
            price: '$7.000'
          },
          'pisco-sour-kappa': {
            name: 'Pisco Sour Kappa',
            desc: '',
            price: '$20.000'
          },
          'pisco-sour-waqar': {
            name: 'Pisco Sour Waqar',
            desc: '',
            price: '$18.000'
          },
          'amaretto-sour': {
            name: 'Amaretto Sour',
            desc: '',
            price: '$11.000'
          },
          'chardonnay-sour': {
            name: 'Chardonnay Sour',
            desc: '',
            price: '$6.000'
          },
          'jerez-sour': {
            name: 'Jerez Sour',
            desc: '',
            price: '$6.000'
          },
          'vodka-sour': {
            name: 'Vodka Sour',
            desc: '',
            price: '$6.000'
          },
          'whisky-sour': {
            name: 'Whisky Sour',
            desc: '',
            price: '$7.000'
          },
          'whisky-sour-black-label': {
            name: 'Whisky Sour J. Walker Black Label',
            desc: '',
            price: '$15.000'
          },
          'whisky-sour-chivas-18': {
            name: 'Whisky Sour Chivas Regal 18 Años',
            desc: '',
            price: '$30.000'
          },

          // === MOJITO ===
          'mojito-tradicional': {
            name: 'Mojito Tradicional',
            desc: '',
            price: '$5.000'
          },
          'mojito-sabores': {
            name: 'Mojito Frambuesa/Maracuyá/Mango',
            desc: '',
            price: '$6.000'
          },
          'mojito-menta-albahaca': {
            name: 'Mojito Menta Albahaca',
            desc: '',
            price: '$6.000'
          },
          'mojito-jack': {
            name: 'Mojito Jack',
            desc: '',
            price: '$11.000'
          },
          'mojito-jaggermeister': {
            name: 'Mojito Jäggermeister',
            desc: '',
            price: '$8.000'
          },
          'mojito-espumante': {
            name: 'Mojito Espumante',
            desc: '',
            price: '$5.000'
          },
          'mojito-sin-alcohol': {
            name: 'Mojito Sin Alcohol',
            desc: '',
            price: '$4.000'
          },

          // === COCKTAILS CLÁSICOS ===
          'alexander': {
            name: 'Alexander',
            desc: '',
            price: '$6.000'
          },
          'alexander-night': {
            name: 'Alexander Night',
            desc: '',
            price: '$6.000'
          },
          'bitter-francesa': {
            name: 'Bitter a la Francesa',
            desc: '',
            price: '$6.000'
          },
          'bitter-batido': {
            name: 'Bitter Batido',
            desc: '',
            price: '$6.000'
          },
          'bloody-mary': {
            name: 'Bloody Mary',
            desc: '',
            price: '$8.000'
          },
          'caipirinha': {
            name: 'Caipirinha',
            desc: '',
            price: '$5.000'
          },
          'caipirisima': {
            name: 'Caipirisima',
            desc: '',
            price: '$5.000'
          },
          'caipiroska': {
            name: 'Caipiroska',
            desc: '',
            price: '$5.000'
          },
          'campari-naranja': {
            name: 'Campari Naranja',
            desc: '',
            price: '$8.000'
          },
          'campari-soda': {
            name: 'Campari Soda',
            desc: '',
            price: '$8.000'
          },
          'campari-tonica': {
            name: 'Campari Tónica',
            desc: '',
            price: '$8.000'
          },
          'clavo-oxidado': {
            name: 'Clavo Oxidado',
            desc: '',
            price: '$10.000'
          },
          'cosmopolitan': {
            name: 'Cosmopolitan',
            desc: '',
            price: '$9.000'
          },
          'daiquiri-tradicional': {
            name: 'Daiquiri Tradicional',
            desc: '',
            price: '$6.000'
          },
          'daiquiri-sabores': {
            name: 'Daiquiri Sabores Frutales',
            desc: '',
            price: '$6.000'
          },
          'el-padrino': {
            name: 'El Padrino',
            desc: '',
            price: '$12.000'
          },
          'john-collins': {
            name: 'John Collins',
            desc: '',
            price: '$6.000'
          },
          'manhattan': {
            name: 'Manhattan',
            desc: '',
            price: '$7.000'
          },
          'martini-dry': {
            name: 'Martini Dry',
            desc: '',
            price: '$9.000'
          },
          'martini-expresso': {
            name: 'Martini Expresso',
            desc: '',
            price: '$9.000'
          },
          'berlin-mule': {
            name: 'Berlin Mule',
            desc: '',
            price: '$11.000'
          },
          'london-mule': {
            name: 'London Mule',
            desc: '',
            price: '$12.000'
          },
          'moscow-mule': {
            name: 'Moscow Mule',
            desc: '',
            price: '$10.000'
          },
          'negroni': {
            name: 'Negroni',
            desc: '',
            price: '$8.000'
          },
          'old-fashioned': {
            name: 'Old Fashioned',
            desc: '',
            price: '$6.000'
          },
          'pina-colada': {
            name: 'Piña Colada',
            desc: '',
            price: '$10.000'
          },
          'primavera-con-licor': {
            name: 'Primavera con Licor',
            desc: '',
            price: '$8.000'
          },
          'primavera-sin-licor': {
            name: 'Primavera sin Licor',
            desc: '',
            price: '$6.000'
          },
          'ruso-blanco': {
            name: 'Ruso Blanco',
            desc: '',
            price: '$7.000'
          },
          'ruso-negro': {
            name: 'Ruso Negro',
            desc: '',
            price: '$7.000'
          },
          'tequila-margarita': {
            name: 'Tequila Margarita',
            desc: '',
            price: '$6.500'
          },
          'tequila-sabores': {
            name: 'Tequila Sabores',
            desc: '',
            price: '$6.500'
          },
          'tom-collins': {
            name: 'Tom Collins',
            desc: '',
            price: '$8.000'
          },
          'vaina': {
            name: 'Vaina',
            desc: '',
            price: '$6.000'
          },
          'vodkatini': {
            name: 'Vodkatini',
            desc: '',
            price: '$6.000'
          },
          'jugo-tomate-alinos': {
            name: 'Jugo De Tomates Con Aliños',
            desc: '',
            price: '$5.000'
          },
          'borgona': {
            name: 'Borgoña',
            desc: '',
            price: '$5.000'
          },
          'sangria': {
            name: 'Sangría',
            desc: '',
            price: '$5.000'
          },
          'sangria-jerez': {
            name: 'Sangría en Jerez',
            desc: '',
            price: '$5.000'
          },
          'chelada': {
            name: 'Chelada',
            desc: '',
            price: '$1.000'
          },
          'michelada': {
            name: 'Michelada',
            desc: '',
            price: '$1.000'
          }
        },

        'espumantes': {
          // COPA DE ESPUMANTE
          'copa-espumante': {
            name: 'Copa Espumante Viña Mar Brut',
            desc: '',
            price: '$5.000'
          },
          'espumante-donoso-brut':{
            name:'Espumante Donoso brut',
            desc:'',
            price:'$20.000'
          },
          

          // ESPUMANTES
          'espumante-chandon-brut': {
            name: 'Espumante Chandon Brut',
            desc: '',
            price: '$25.000'
          },
          'espumante-chandon-demi-sec': {
            name: 'Espumante Chandon Demi Sec',
            desc: '',
            price: '$25.000'
          },

          'espumante-riccadonna-asti': {
            name: 'Espumante Riccadonna Asti',
            desc: '',
            price: '$25.000'
          },
          'espumante-riccadonna-chardonnay': {
            name: 'Espumante Riccadonna Chardonnay',
            desc: '',
            price: '$25.000'
          },
          'espumante-riccadonna-moscato': {
            name: 'Espumante Riccadonna Moscato',
            desc: '',
            price: '$25.000'
          },
          'espumante-riccadonna-prosecco': {
            name: 'Espumante Riccadonna Prosecco',
            desc: '',
            price: '$25.000'
          },
          'espumante-undurraga': {
            name: 'Espumante Undurraga',
            desc: '',
            price: '$15.000'
          },
          'espumante-valdivieso': {
            name: 'Espumante Valdivieso Caballo loco',
            desc: '',
            price: '$55.000'
          },
          // CHAMPAGNE
          'champagne-dom-perignon': {
            name: 'Champagne Dom Pérignon',
            desc: '',
            price: '$450.000'
          },

          // VALLE DEL ITATA
          'espumante-berta-extra-brut': {
            name: 'Espumante Berta Extra Brut',
            desc: '',
            price: '$23.000'
          },
          'espumante-berta-dulce-doux': {
            name: 'Espumante Berta Dulce Doux',
            desc: '',
            price: '$23.000'
          }
        },

        'jugos-bebidas': {
          // AGUAS MINERALES
          'acqua-panna': {
            name: 'Acqua Panna',
            desc: '',
            price: '$6.000'
          },
          'agua-vital-330': {
            name: 'Agua Vital 330ml',
            desc: '',
            price: '$3.500'
          },
          'san-pellegrino-250': {
            name: 'San Pellegrino 250ml',
            desc: '',
            price: '$5.000'
          },
          'san-pellegrino-505': {
            name: 'San Pellegrino 505ml',
            desc: '',
            price: '$6.000'
          },

          // AGUAS TÓNICAS Y ENERGÉTICAS
          'fentimans-ginger-beer': {
            name: 'Fentimans Ginger Beer',
            desc: '',
            price: '$5.000'
          },
          'fentimans-tonic-water': {
            name: 'Fentimans Tonic Water',
            desc: '',
            price: '$5.000'
          },
          'thomas-henry-ginger-beer': {
            name: 'Thomas Henry Ginger Beer',
            desc: '',
            price: '$5.000'
          },
          'thomas-henry-tonic': {
            name: 'Thomas Henry Tonic Water',
            desc: '',
            price: '$5.000'
          },
          'canada-dry-tonica-zero': {
            name: 'Canada Dry Tónica Zero',
            desc: '',
            price: '$3.500'
          },
          'schweppes-tonica': {
            name: 'Schweppes Tónica',
            desc: '',
            price: '$3.500'
          },
          'red-bull': {
            name: 'Red Bull',
            desc: '',
            price: '$4.000'
          },
          'red-bull-sugar-free': {
            name: 'Red Bull Sugar Free',
            desc: '',
            price: '$4.000'
          },

          // JUGOS NATURALES
          'jugos-naturales': {
            name: 'Jugos Naturales',
            desc: '',
            price: '$4.000'
          },
          'jugo-tomate-alinos': {
            name: 'Jugo de Tomate con Aliños',
            desc: '',
            price: '$5.000'
          },

          // LIMONADAS
          'limonada-menta-frambuesa': {
            name: 'Limonada Menta & Frambuesa',
            desc: '',
            price: '$5.000'
          },
          'limonada-con-mineral': {
            name: 'Limonada con Mineral',
            desc: '',
            price: '$3.500'
          },
          'limonada-con-menta': {
            name: 'Limonada con Menta',
            desc: '',
            price: '$4.000'
          },
          'limonada-menta-jengibre': {
            name: 'Limonada Menta & Jengibre',
            desc: '',
            price: '$4.000'
          },

          // BEBIDAS DE FANTASÍA
          'coca-cola': {
            name: 'Coca Cola',
            desc: '',
            price: '$3.500'
          },
          'fanta': {
            name: 'Fanta',
            desc: '',
            price: '$3.500'
          },
          'sprite': {
            name: 'Sprite',
            desc: '',
            price: '$3.500'
          },
          'schweppes-ginger-ale': {
            name: 'Schweppes Ginger Ale',
            desc: '',
            price: '$3.500'
          },
          'nectar-andina': {
            name: 'Néctar Andina',
            desc: '',
            price: '$3.500'
          }
        },
      },
      contact: {
        title: "Contáctanos",
        subtitle: "Estamos aquí para atenderte",
        address: "Dirección",
        phone: "Teléfono",
        email: "Email",
        schedule: "Horario",
        scheduleText: "Lunes - Sábado: 12:30 - 23:00\n Domingo: 12:30 - 22:00",
        form: {
          name: "Nombre",
          email: "Email",
          phone: "Teléfono",
          message: "Mensaje",
          send: "Enviar Mensaje",
          sending:"Enviando correo...",
          error:"Error al enviar, intente nuevamente",
          success: "¡Gracias por contactarnos! Te responderemos pronto."
        }
      },
      footer: {
        rights: "Todos los derechos reservados"
      }
    }
  },
  en: {
    translation: {
      nav: {
        home: "Home",
        menu: "Menu",
        about: "About Us",
        salones: "Our Spaces",
        contact: "Contact"
      },
      hero: {
        title: "Premium Experience",
        subtitle: "in Meats and Seafood",
        description: "Enjoy the finest cuts in an atmosphere of elegance and warmth",
        viewMenu: "View Menu"
      },
      about: {
        title: "Our Story",
        text1: "At Aquarium, we merge culinary tradition with contemporary excellence. We specialize in premium meats and the finest seafood.",
        text2: "Each dish is a masterpiece crafted with the highest quality ingredients, prepared by our expert chefs in an environment that combines warmth and sophistication.",
        years: "Years of Experience",
        premium: "Premium Meats",
        rating: "Rating"
      },
      salones: {
        title: "Our Spaces",
        subtitle: "Unique settings for every occasion",
        cta: "Book Now",
        spaces: {
          principal: {
            name: "Main Dining Hall",
            capacity: "Up to 80 guests",
            description: "Our most spacious and elegant area, perfect for large celebrations, corporate events, and banquets. Features adjustable ambient lighting, professional sound system, and sophisticated décor.",
            features: ["Air conditioning", "Sound system", "Ambient lighting", "Wheelchair accessible"]
          },
          privado: {
            name: "Private VIP Room",
            capacity: "15 to 30 guests",
            description: "Intimate and exclusive space ideal for business meetings, special family dinners, and private celebrations. Offers complete privacy with personalized service and à la carte menu.",
            features: ["Fully private", "Exclusive service", "Customized menu", "Custom décor"]
          },
          terraza: {
            name: "Outdoor Terrace",
            capacity: "Up to 50 guests",
            description: "Enjoy an alfresco experience on our beautiful terrace. Perfect for daytime events, cocktail parties, and casual celebrations with panoramic views and a relaxed atmosphere.",
            features: ["Outdoor setting", "Panoramic views", "Outdoor heating", "Natural ambiance"]
          },
          lounge: {
            name: "Lounge & Bar",
            capacity: "Up to 40 guests",
            description: "Versatile space with modern and sophisticated ambiance. Ideal for after-work gatherings, corporate cocktails, and social meetings. Features full bar and comfortable lounge seating.",
            features: ["Full bar", "Ambient music", "Lounge area", "LED lighting"]
          }
        },
        events: {
          title: "Special Events",
          description: "We organize all types of celebrations",
          types: ["Weddings & Anniversaries", "Corporate Events", "Birthdays & Celebrations", "Business Meetings", "Bridal & Baby Showers", "Social Gatherings"]
        }
      },
      menu: {
        title: "Our Menu",
        subtitle: "Discover our specialties",
        categories: {
          "entradas-frias": "Cold Appetizers",
          "entradas-calientes": "Hot Appetizers",
          "agregados": "Sides",
          "sopas-cremas": "Soups & Creams",
          "ensaladas": "Salads",
          "carnes": "Premium Meats",
          "pescados": "Seafood",
          "pastas": "Fresh Pasta",
          "veganos": "Vegan Dishes",
          "celiacos": "Gluten-Free Dishes",
          "salsas" : "Sauces",
          "postres": "Desserts",
          "tablas": "Platters & Snacks"
        }
      },
      menuItems: {
        'entradas-frias': {
          'carpaccio-de-atun': {name: 'Tuna Carpaccio', desc: 'Thin slices of tuna, seasoned with Dijon mustard dressing, mayonnaise and lemon juice, accompanied with capers and gruyere cheese.'},
          'carpaccio-de-filete': {name: 'Beef Tenderloin Carpaccio', desc: 'Thin slices of beef tenderloin, seasoned with Dijon mustard dressing, mayonnaise and lemon juice, accompanied with capers and gruyere cheese.'},
          'carpaccio-de-salmon': {name: 'Salmon Carpaccio', desc: 'Thin slices of salmon, seasoned with Dijon mustard dressing, mayonnaise and lemon juice, accompanied with capers and gruyere cheese.'},
          'centolla-del-mar-del-sur': {name: 'Southern King Crab', desc: 'Exquisite Southern King Crab meat, steamed, accompanied with mayonnaise and green sauce.'},
          'ceviche-acapulco': {name: 'Acapulco Ceviche', desc: 'Tasty fish cut into cubes and marinated in lemon juice, bell pepper, red onion, avocado, cilantro, salt and pepper.'},
          'ceviche-de-locos': {name: 'Chilean Abalone Ceviche', desc: 'Exquisite Chilean abalone cubes marinated in lemon juice, bell pepper, red onion, cilantro, salt and pepper.'},
          'ceviche-de-pulpo': {name: 'Octopus Ceviche', desc: 'Tasty octopus pieces marinated in lemon juice, bell pepper, red onion, cilantro, salt and pepper.'},
          'ceviche-estilo-mexicano': {name: 'Mexican Style Ceviche', desc: 'Tasty combinations of fish and avocado cut into cubes, marinated in lemon juice, bell pepper, red onion, cilantro, green chili.'},
          'ceviche-de-salmon-acapulco': {name: 'Salmon Acapulco Ceviche', desc: 'Delicious combination of salmon, abalones and shrimp accompanied by red onion, bell pepper mix and avocado seasoned with lemon juice, salt, pepper and Tigers Milk.'},
          'ceviche-tropical' : {name: 'Tropical Ceviche', desc: 'Fresh preparation of salmon marinated in lemon juice, bell pepper, mango chunks, coconut milk, cilantro.'},
          'locos-en-salsa-verde': {name: 'Chilean Abalone in Green Sauce', desc: 'Delicious Premium Chilean Abalone, accompanied with mayonnaise and green sauce. Optional potato salad with mayonnaise.'},
          'tartara-de-filete': {name: 'Beef Tenderloin Tartare', desc: 'Fine cuts of beef tenderloin, dressed with capers, tartar sauce, onion and cilantro, with a touch of mustard, lemon and mayonnaise.'},
          'crudo-de-filete': {name: 'Beef Tenderloin Crudo', desc: 'Fine cuts of beef tenderloin, dressed with onion and cilantro, with a touch of lemon, salt, pepper and olive oil.'},
        },
        'entradas-calientes': {
          'brocheta-de-camarones-y-jamon-serrano': {name: 'Shrimp and Serrano Ham Skewers', desc: 'Delicious Ecuadorian Shrimp tails wrapped in serrano ham, with tomato sauce, oregano and black olives.'},
          'camarones-ecuatorianos-a-la-primavera': {name: 'Ecuadorian Shrimp a la Primavera', desc: 'Ecuadorian Shrimp tails sautéed with onions, peppers and cherry tomatoes. Flavored with white wine and merquén.'},
          'camarones-al-ajillo': {name: 'Garlic Shrimp', desc: 'Ecuadorian Shrimp sautéed with garlic, flavored with white wine and pepper.'},
          'camarones-al-olivo': {name: 'Shrimp in Olive Oil', desc: 'Ecuadorian Shrimp sautéed in olive oil with a touch of pepper.'},
          'camarones-al-pil-pil': {name: 'Pil Pil Shrimp', desc: 'Shrimp sautéed with garlic and cacho de cabra chili, flavored with white wine, pepper and parsley.'},
          'langosta-de-juan-fernandez': {name: 'Juan Fernández Lobster', desc: 'Exquisite crustacean boiled in seafood stock and baked with herb butter, flavored with whiskey.'},
          'machas-a-la-parmesana': {name: 'Parmesan Razor Clams', desc: 'Tasty northern razor clam tongues, bathed in three cheese sauce and gratinated with parmesan.'},
          'ostiones-a-la-parmesana': {name: 'Parmesan Scallops', desc: 'Tasty Scallops bathed in three cheese sauce and gratinated with parmesan cheese.'},
          'pulpo-a-la-parrilla': {name: 'Salmon Acapulco Ceviche', desc: 'Delicious 250 gr portion of salmon with 6 Ecuadorian shrimp, 200 gr of Chilean abalone, red onion, avocado and cilantro.'},
          'pulpo-salteado-al-ajillo' : {name: 'Grilled Octopus', desc: 'Exquisite Octopus tentacles grilled, marinated in olive oil with paprika, garlic and oregano.'},
          'pulpo-salteado-al-pil-pil': {name: 'Sautéed Garlic Octopus', desc: 'Octopus tentacles sautéed with garlic, paprika and white wine.'},
          'centolla-entera': {name: 'Whole King Crab', desc: 'Exquisite marine crustacean boiled in seafood stock, mounted on a green mix and stuffed with king crab meat. Approximate weight: 3 kg.'},
        },
        'agregados': {
          'anillos-de-cebolla': { name: 'Onion Rings', desc: '' },
          'arroz': { name: 'Rice', desc: '' },
          'champinones-salteados': { name: 'Sautéed Mushrooms', desc: '' },
          'choclo-a-la-crema': { name: 'Creamed Corn', desc: '' },
          'espinacas-a-la-crema': { name: 'Creamed Spinach', desc: '' },
          'panache-de-verduras': { name: 'Vegetable Medley', desc: '' },
          'papas-a-la-crema-acida': { name: 'Sour Cream Potatoes', desc: '' },
          'papas-chauchas': { name: 'Chauchas Potatoes', desc: '' },
          'papas-cocidas': { name: 'Boiled Potatoes', desc: '' },
          'papas-duquesas': { name: 'Duchess Potatoes', desc: '' },
          'papas-fritas': { name: 'French Fries', desc: '' },
          'papas-hilo': { name: 'Shoestring Potatoes', desc: '' },
          'papas-salteadas': { name: 'Sautéed Potatoes', desc: '' },
          'pure-de-papas': { name: 'Mashed Potatoes', desc: '' },
          'pure-de-zapallo': { name: 'Mashed Squash', desc: '' },
          'pure-gratinado': { name: 'Gratin Mashed Potatoes', desc: '' }
        },
        'sopas-cremas': {
          'ajiaco': {name: 'Ajiaco', desc: 'Delicious preparation made with beef, onion, potato and bell pepper. Optional Cacho de Cabra Chili.'},
          'calderete-de-langosta': {name: 'Lobster Stew', desc: 'Exquisite crustacean bisque broth, lobster meat, vegetables and potatoes with fresh cilantro.'},
          'caldillo-de-congrio': {name: 'Conger Eel Soup', desc: 'Traditional Chilean broth of fish fumet, golden conger eel, vegetables and potatoes with cilantro.'},
          'crema-de-centolla': {name: 'King Crab Cream', desc: 'Exquisite king crab meat cream with sofrito, vegetable broth and fresh cream.'},
          'crema-de-puerros': {name: 'Leek Cream', desc: 'Delicious cream of leeks and fresh vegetables, vegetable broth and fresh cream.'},
          'crema-de-zapallo': {name: 'Squash Cream', desc: 'Natural cream prepared with squash, vegetables and a smooth touch of fresh cream.'},
          'crema-de-tomate': {name: 'Tomato Cream', desc: 'Natural cream of fresh tomatoes with vegetables and fresh cream.'},
          'crema-de-esparragos': {name: 'Asparagus Cream', desc: 'Delicious cream of fresh asparagus with vegetable broth.'},
          'sopa-aquarium': {name: 'Aquarium Soup', desc: 'Delicious fish fumet broth, conger eel and assorted seafood, flavored with white wine.'},
          'consome-ave-reina': {name: 'Queen Chicken Consommé', desc: 'Delicious chicken broth with chicken pieces and vegetables.'},
        },
        'ensaladas': {
          'ensalada-cesar': {name: 'Caesar Salad', desc: 'Exquisite salad of lettuce, arugula, pecorino cheese in slices, croutons and French dressing.'},
          'ensalada-cesar-con-camarones': {name: 'Caesar Salad with Shrimp', desc: 'Lettuce, arugula, pecorino cheese, shrimp breaded in panko, croutons and French dressing.'},
          'ensalada-cesar-con-pollo': {name: 'Caesar Salad with Chicken', desc: 'Lettuce, arugula, pecorino cheese, chicken breaded in panko, croutons and French dressing.'},
          'ensalada-cesar-con-pollo-y-camarones': {name: 'Caesar Salad with Chicken and Shrimp', desc: 'Lettuce, pecorino cheese, croutons, chicken and shrimp, French dressing.'},
          'ensalada-de-manzanas': {name: 'Apple Salad', desc: 'Tasty combination of lettuce, mushrooms, corn, walnuts and red and/or green apples.'},
          'ensalada-griega': {name: 'Greek Salad', desc: 'Fresh combination of tomatoes, pearl and red onion, bell pepper, olives and goat cheese.'},
          'ensalada-silvestre': {name: 'Wild Salad', desc: 'Fresh combination of lettuce, arugula, watercress, pearl onion and juicy orange segments.'},
          'ensalada-verde': {name: 'Green Salad', desc: 'Light combination of fresh lettuce leaves, arugula, avocado, watercress and spinach.'},
        },
        'carnes': {
          'asado-de-tira-angus-600-grs': {name: 'Angus Short Ribs 600 grs', desc: 'Exquisite Angus rib, grilled with sea salt.'},
          'asado-de-tira-angus-800-grs': {name: 'Angus Short Ribs 800 grs', desc: 'Exquisite Angus rib, slow-cooked in the oven for 8 hours.'},
          'baby-beef-angus-450-grs': {name: 'Angus Baby Beef 450 grs', desc: 'Tasty marbled Angus tenderloin wrapped in bacon and grilled.'},
          'bife-chorizo-wagyu-400-grs': {name: 'Wagyu Strip Loin 400 grs', desc: 'Exquisite Wagyu strip loin grilled. Tender meat with infiltrated fat that provides great flavor.'},
          'bife-chorizo-angus-400-grs': {name: 'Angus Strip Loin 400 grs', desc: 'Exquisite Angus strip loin grilled with fat layer that provides great flavor.'},
          'bife-relleno-solocarnes-400-grs': {name: 'Solocarnes Stuffed Steak 400 grs', desc: 'Grilled strip loin with spinach, bacon, tomato, bell pepper and parmesan cheese.'},
          'cordero-de-bulnes-450-grs': {name: 'Bulnes Lamb 450 grs', desc: 'Exquisite grilled lamb cuts, marinated in white wine with rosemary and garlic, with mashed potatoes.'},
          'entrana-300-grs': {name: 'Skirt Steak 300 grs', desc: 'Cut of great flavor and tenderness, grilled, seasoned with grill salt.'},
          'entrana-de-wagyu-400-grs': {name: 'Wagyu Skirt Steak 400 grs', desc: 'Wagyu cut of great flavor and tenderness, grilled with grill salt.'},
          'filete-aquarium-300-grs': {name: 'Aquarium Tenderloin 300 grs', desc: 'Grilled tenderloin medallion, stuffed with Ecuadorian shrimp on white wine sauce.'},
          'filete-grille-300-grs': {name: 'Grilled Tenderloin 300 grs', desc: 'Tasty Angus tenderloin medallion grilled with grill salt.'},
          'porterhouse-steak-700-grs': {name: 'Porterhouse Steak 700 grs', desc: 'Extraordinary cut that combines strip loin and tenderloin, seasoned with sea salt.'},
          'plateada-al-horno': {name: 'Oven-Baked Beef Brisket', desc: 'Tasty piece of beef brisket baked with vegetables and white wine in juice reduction.'},
          'tomahawk-1-5-kgs': {name: 'Tomahawk 1.5 kgs', desc: 'Exquisite grilled Strip/Rib Eye chop seasoned with sea salt.'},
        },
        'pescados': {
          'atun-del-ecuador': {name: 'Ecuadorian Tuna', desc: 'Exquisite Ecuadorian tuna seared on the grill with fine herbs, merquén and salt.'},
          'congrio-dorado': {name: 'Golden Conger Eel', desc: 'Tasty golden conger eel prepared with butter, flavored with white wine.'},
          'corvina-con-camarones-salteados': {name: 'Sea Bass with Sautéed Shrimp', desc: 'Sea bass fillet with butter and Ecuadorian shrimp sautéed in olive oil.'},
          'corvina-grille': {name: 'Grilled Sea Bass', desc: 'Delicious sea bass fillet grilled with butter and white wine.'},
          'corvina-roulade': {name: 'Sea Bass Roulade', desc: 'Sea bass fillet stuffed with shrimp, asparagus and capers on white wine sauce.'},
          'merluza-austral-grille': {name: 'Grilled Southern Hake', desc: 'Exquisite Southern hake fillet grilled with white wine.'},
          'salmon-grille-con-camarones': {name: 'Grilled Salmon with Shrimp', desc: 'Salmon fillet with butter and Ecuadorian shrimp flavored with white wine.'},
          'salmon-grille': {name: 'Grilled Salmon', desc: 'Delicious salmon fillet prepared with butter.'},
        },
        'pastas': {
          'canelones-con-centolla': {name: 'Cannelloni with King Crab', desc: 'Pasta stuffed with King Crab, with three cheese sauce gratinated with parmesan.'},
          'canelones-con-locos': {name: 'Cannelloni with Chilean Abalone', desc: 'Pasta stuffed with Chilean abalone, with Ecuadorian shrimp sauce gratinated with parmesan.'},
          'canelones-con-pollo': {name: 'Cannelloni with Chicken', desc: 'Pasta stuffed with chicken, with three cheese sauce gratinated with parmesan.'},
          'espagueti': {name: 'Spaghetti', desc: 'Exquisite fresh pasta, sautéed with butter or olive oil.'},
          'espagueti-al-pesto': {name: 'Pesto Spaghetti', desc: 'Spaghetti sautéed with basil paste, olive oil, garlic and walnuts.'},
          'lasana-bolonesa': {name: 'Bolognese Lasagna', desc: 'Layered pasta with bolognese sauce, three cheeses, mozzarella and gratinated parmesan.'},
          'noquis-bolonesa-18-unidades': {name: 'Bolognese Gnocchi (18 units)', desc: 'Potato pasta, flour and nutmeg with bolognese sauce.'},
          'pappardelle-fruto-di-mare': {name: 'Pappardelle Fruto di Mare', desc: 'Ribbon pasta sautéed with seafood, tomatoes, basil, oregano and fresh cream.'},
          'ravioles-con-espinacas': {name: 'Spinach Ravioli', desc: 'Pasta stuffed with spinach, parmesan cheese and nutmeg.'},
          'sorrentinos-de-centolla': {name: 'King Crab Sorrentinos', desc: 'Pasta stuffed with king crab, leeks, cream cheese and parmesan with basil and cherry tomatoes.'},
        },

        'veganos': {
          'croquetas-de-lentejas-con-salsa-pomodoro': {name: 'Lentil Croquettes with Pomodoro Sauce', desc: 'Lentil croquettes breaded in panko with pomodoro sauce and white rice.'},
          'hamburguesa-de-garbanzos': {name: 'Chickpea Burger', desc: 'Chickpea and vegetable burger with fresh salad and mustard dressing.'},
          'quinotto-de-champinones': {name: 'Mushroom Quinotto', desc: 'Quinoa preparation with vegetable broth, fresh chives and toasted almonds.'},
        },

        'celiacos': {
          'espirales-de-arroz-con-camarones': {name: 'Rice Spirals with Shrimp', desc: 'Rice flour pasta sautéed with shrimp, vegetables, tomatoes, oregano and basil.'},
          'lomo-liso-con-papas-rusticas': {name: 'Strip Loin with Rustic Potatoes', desc: 'Grilled strip loin with sea salt, rustic potatoes and sautéed carrots.'},
          'merluza-austral-con-verduras': {name: 'Southern Hake with Vegetables', desc: 'Grilled Southern hake fillet with vegetables and walnuts sautéed in olive oil.'},
        },

        'postres': {
          'churros-caseros': {name: 'Homemade Churros', desc: 'Soft fried dough with powdered sugar, accompanied with dulce de leche and vanilla ice cream.'},
          'creme-brulee': {name: 'Crème Brûlée', desc: 'Delicious French dessert of fresh cream, egg yolks, vanilla and crunchy caramel.'},
          'globo-de-chocolate': {name: 'Chocolate Globe', desc: 'Delicate chocolate sphere that hides a dessert inside.'},
          'helados-artesanales': {name: 'Artisan Ice Cream', desc: 'Delicious homemade ice creams.'},
          'leche-asada': {name: 'Leche Asada', desc: 'Fresh homemade dessert of eggs and milk flavored with orange and vanilla.'},
          'panqueque-celestino': {name: 'Celestino Pancake', desc: 'Pancakes filled with dulce de leche, powdered sugar and vanilla ice cream.'},
          'papayas-al-jugo': {name: 'Papayas in Juice', desc: 'Juicy papayas in juice, accompanied with optional heavy cream.'},
          'picarones': {name: 'Picarones', desc: 'Traditional Chilean dessert. Fried pumpkin dough rings with Chancaca sauce.'},
          'suspiro-limeno': {name: 'Suspiro Limeño', desc: 'Peruvian dessert of condensed and evaporated milk, flavored with Port wine and Italian meringue.'},
          'tiramisu': {name: 'Tiramisu', desc: 'Italian dessert of cream cheese, vanilla, aged wine and ristretto coffee.'},
          'volcan-de-chocolate': {name: 'Chocolate Volcano', desc: 'Chocolate sponge cake with liquid center, accompanied with vanilla ice cream.'},
        },

        'salsas': {
          'salsa-4-pimientas': {name: '4 Pepper Sauce', desc: 'Preparation based on white sauce, selection of 4 peppers and a touch of cream and cognac.'},
          'salsa-al-pesto': {name: 'Pesto Sauce', desc: 'Preparation based on basil, garlic, olive oil and walnuts.'},
          'salsa-alfredo': {name: 'Alfredo Sauce', desc: 'Preparation based on three cheese sauce and ham pieces.'},
          'salsa-arrabiata': {name: 'Arrabiata Sauce', desc: 'Preparation based on tomato sauce, smoked bacon, capers and a touch of garlic, basil and merquén.'},
          'salsa-bolonesa': {name: 'Bolognese Sauce', desc: 'Preparation made with tomato sauce, ground beef and vegetables.'},
          'salsa-de-centolla': {name: 'King Crab Sauce', desc: 'Smooth sauce made with king crab meat, fresh cream and a touch of oregano.'},
          'salsa-de-locos': {name: 'Chilean Abalone Sauce', desc: 'Delicious sauce made with Chilean abalone pieces, fresh cream and a touch of oregano.'},
          'salsa-de-mostaza': {name: 'Mustard Sauce', desc: 'Preparation based on Dijon mustard, fresh cream and a touch of pepper.'},
          'salsa-de-pulpo': {name: 'Octopus Sauce', desc: 'Tasty sauce made with octopus pieces.'},
          'salsa-pomodoro': {name: 'Pomodoro Sauce', desc: 'Tasty preparation based on tomato sauce, onions, olives and oregano.'},
        },
        'tablas': {
          'tabla-aquarium-4-locos': {name: 'Aquarium Platter 4 Abalones', desc: 'Composed of Chilean Abalone, Grilled Octopus, Shrimp in olive oil and Parmesan razor clams.'},
          'tabla-aquarium-premium': {name: 'Aquarium Premium Platter', desc: '8 Chilean Abalone, Grilled Octopus, Shredded King Crab, Shrimp in olive oil and Parmesan razor clams.'},
          'tabla-de-carnes-y-guacamole': {name: 'Meat and Guacamole Platter', desc: 'Chicken, Beef Tenderloin and Pork Tenderloin sautéed with mushrooms and guacamole.'},
          'tabla-mixta-solocarnes': {name: 'Solocarnes Mixed Platter', desc: 'Mix of meats, seafood and vegetables: beef, chicken, panko shrimp, calamari with fresh salad.'},
        },
      },
      contact: {
        title: "Contact Us",
        subtitle: "We're here to serve you",
        address: "Address",
        phone: "Phone",
        email: "Email",
        schedule: "Schedule",
        scheduleText: "Monday - Saturday: 12:30 PM - 23:00 PM\n Sunday: 12:30 PM - 22:00 PM",
        form: {
          name: "Name",
          email: "Email",
          phone: "Phone",
          message: "Message",
          send: "Send Message",
          success: "Thank you for contacting us! We'll respond soon."
        }
      },
      footer: {
        rights: "All rights reserved"
      }
    }
  },
  pt: {
    translation: {
      nav: {
        home: "Início",
        menu: "Menu",
        about: "Sobre Nós",
        salones: "Nossos Espaços",
        contact: "Contato"
      },
      hero: {
        title: "Experiência Premium",
        subtitle: "em Carnes e Frutos do Mar",
        description: "Desfrute dos cortes mais selecionados em um ambiente de elegância e aconchego",
        viewMenu: "Ver Menu"
      },
      about: {
        title: "Nossa História",
        text1: "No Aquarium, fundimos a tradição culinária com a excelência contemporânea. Especializamo-nos em carnes premium e os melhores frutos do mar.",
        text2: "Cada prato é uma obra-prima elaborada com ingredientes da mais alta qualidade, preparados por nossos chefs especialistas em um ambiente que combina aconchego e sofisticação.",
        years: "Anos de Experiência",
        premium: "Carnes Premium",
        rating: "Avaliação"
      },
      salones: {
        title: "Nossos Espaços",
        subtitle: "Ambientes únicos para cada ocasião",
        cta: "Reservar Agora",
        spaces: {
          principal: {
            name: "Salão Principal",
            capacity: "Até 80 pessoas",
            description: "Nosso espaço mais amplo e elegante, perfeito para grandes celebrações, eventos corporativos e banquetes. Conta com iluminação ambiental regulável, sistema de som profissional e decoração sofisticada.",
            features: ["Ar condicionado", "Sistema de som", "Iluminação ambiental", "Acessível para cadeirantes"]
          },
          privado: {
            name: "Salão Privativo VIP",
            capacity: "De 15 a 30 pessoas",
            description: "Espaço íntimo e exclusivo ideal para reuniões de negócios, jantares familiares especiais e celebrações privadas. Oferece total privacidade com serviço personalizado e menu à la carte.",
            features: ["Totalmente privado", "Serviço exclusivo", "Menu personalizado", "Decoração sob medida"]
          },
          terraza: {
            name: "Terraço Exterior",
            capacity: "Até 50 pessoas",
            description: "Desfrute de uma experiência ao ar livre em nosso belo terraço. Perfeito para eventos diurnos, coquetéis e celebrações informais com vista panorâmica e ambiente relaxado.",
            features: ["Ao ar livre", "Vista panorâmica", "Aquecimento externo", "Ambiente natural"]
          },
          lounge: {
            name: "Lounge & Bar",
            capacity: "Até 40 pessoas",
            description: "Espaço versátil com ambiente moderno e sofisticado. Ideal para after-office, coquetéis empresariais e reuniões sociais. Conta com bar completo e área de sofás confortáveis.",
            features: ["Bar completo", "Música ambiente", "Área lounge", "Iluminação LED"]
          }
        },
        events: {
          title: "Eventos Especiais",
          description: "Organizamos todo tipo de celebrações",
          types: ["Casamentos e Aniversários", "Eventos Corporativos", "Aniversários e Celebrações", "Reuniões de Negócios", "Despedidas e Chás de Bebê", "Eventos Sociais"]
        }
      },
      menu: {
        title: "Nosso Menu",
        subtitle: "Descubra nossas especialidades",
        categories: {
          "entradas-frias": "Entradas Frias",
          "entradas-calientes": "Entradas Quentes",
          "agregados": "Acompanhamentos",
          "sopas-cremas": "Sopas e Cremes",
          "ensaladas": "Saladas",
          "carnes": "Carnes Premium",
          "pescados": "Frutos do Mar",
          "pastas": "Massas Frescas",
          "veganos": "Pratos Veganos",
          "celiacos": "Pratos sem Glúten",
          "salsas" : "Molhos",
          "postres": "Sobremesas",
          "tablas": "Tábuas e Petiscos"
        }
      },
      menuItems: {
        'entradas-frias': {
          'carpaccio-de-atun': {name: 'Carpaccio de Atum', desc: 'Finas lâminas de atum, temperadas com molho de mostarda Dijon, maionese e suco de limão, acompanhadas de alcaparras e queijo gruyere.'},
          'carpaccio-de-filete': {name: 'Carpaccio de Filé', desc: 'Finas lâminas de filé, temperadas com molho de mostarda Dijon, maionese e suco de limão, acompanhadas de alcaparras e queijo gruyere.'},
          'carpaccio-de-salmon': {name: 'Carpaccio de Salmão', desc: 'Finas lâminas de salmão, temperadas com molho de mostarda Dijon, maionese e suco de limão, acompanhadas de alcaparras e queijo gruyere.'},
          'centolla-del-mar-del-sur': {name: 'Centolla do Mar do Sul', desc: 'Exquisita carne de Centolla, cozida no vapor, acompanhada de maionese e molho verde.'},
          'ceviche-acapulco': {name: 'Ceviche Acapulco', desc: 'Saboroso peixe cortado em cubos e marinado em suco de limão, pimentão, cebola roxa, abacate, coentro, sal e pimenta.'},
          'ceviche-de-locos': {name: 'Ceviche de Locos', desc: 'Exquisitos cubos de locos marinados em suco de limão, pimentão, cebola roxa, coentro, sal e pimenta.'},
          'ceviche-de-pulpo': {name: 'Ceviche de Polvo', desc: 'Saborosos pedaços de polvo marinados em suco de limão, pimentão, cebola roxa, coentro, sal e pimenta.'},
          'ceviche-estilo-mexicano': {name: 'Ceviche Estilo Mexicano', desc: 'Saborosas combinações de peixe e abacate cortadas em cubos, marinadas em suco de limão, pimentão, cebola roxa, coentro, pimenta verde.'},
          'ceviche-de-salmon-acapulco': {name: 'Ceviche de Salmão Acapulco', desc: 'Deliciosa combinação de salmão, locos e camarões acompanhados de cebola roxa, mix de pimentão e abacate temperados com suco de limão, sal, pimenta e Leite de Tigre.'},
          'ceviche-tropical': {name: 'Ceviche Tropical', desc: 'Fresca preparação de salmão marinado em suco de limão, pimentão, pedaços de manga, leite de coco, coentro.'},
          'locos-en-salsa-verde': {name: 'Locos em Molho Verde', desc: 'Deliciosos Locos Premium, acompanhados de maionese e molho verde. Opcional salada de batatas com maionese.'},
          'tartara-de-filete': {name: 'Tártaro de Filé', desc: 'Finos cortes de filé, temperados com alcaparras, tártaro, cebola e coentro, com um toque de mostarda, limão e maionese.'},
          'crudo-de-filete': {name: 'Crudo de Filé', desc: 'Finos cortes de filé, temperados com cebola e coentro, com um toque de limão, sal, pimenta e azeite de oliva.'},
        },

        'entradas-calientes': {
          'brocheta-de-camarones-y-jamon-serrano': {name: 'Espetinho de Camarões e Presunto Serrano', desc: 'Deliciosas caudas de Camarão Equatoriano envoltas em presunto serrano, com molho de tomate, orégano e azeitonas pretas.'},
          'camarones-ecuatorianos-a-la-primavera': {name: 'Camarões Equatorianos à Primavera', desc: 'Caudas de Camarões Equatorianos salteadas com cebolas, pimentões e tomates cereja. Aromatizadas com vinho branco e merquén.'},
          'camarones-al-ajillo': {name: 'Camarões ao Alho', desc: 'Camarões Equatorianos salteados com alho, aromatizados com vinho branco e pimenta.'},
          'camarones-al-olivo': {name: 'Camarões ao Azeite', desc: 'Camarões Equatorianos salteados em azeite de oliva com um toque de pimenta.'},
          'camarones-al-pil-pil': {name: 'Camarões ao Pil Pil', desc: 'Camarões salteados com alho e pimenta cacho de cabra, aromatizados com vinho branco, pimenta e salsa.'},
          'langosta-de-juan-fernandez': {name: 'Lagosta de Juan Fernández', desc: 'Exquisito crustáceo fervido em fundo de frutos do mar e assado com manteiga às ervas finas, aromatizado com whisky.'},
          'machas-a-la-parmesana': {name: 'Machas à Parmesana', desc: 'Saborosas línguas de machas do norte, banhadas com molho de três queijos e gratinadas com parmesão.'},
          'ostiones-a-la-parmesana': {name: 'Ostras à Parmesana', desc: 'Saborosas Ostras banhadas com molho de três queijos e gratinadas com queijo parmesão.'},
          'pulpo-a-la-parrilla': {name: 'Polvo na Grelha', desc: 'Exquisitos tentáculos de Polvo assados na grelha, macerados em azeite de oliva com páprica, alho e orégano.'},
          'pulpo-salteado-al-ajillo': {name: 'Polvo Salteado ao Alho', desc: 'Tentáculos de Polvo salteados com alho, páprica e vinho branco.'},
          'pulpo-salteado-al-pil-pil': {name: 'Polvo Salteado ao Pil Pil', desc: 'Polvo salteado com alho, páprica e pimenta cacho de cabra, aromatizado com vinho branco.'},
          'centolla-entera': {name: 'Centolla Inteira', desc: 'Exquisito crustáceo marinho fervido em fundo de frutos do mar, montado em um mix verde e recheado de carne de centolla. Peso aproximado: 3 kg.'},
        },
        'agregados': {
          'anillos-de-cebolla': { name: 'Anéis de Cebola', desc: '' },
          'arroz': { name: 'Arroz', desc: '' },
          'champinones-salteados': { name: 'Cogumelos Salteados', desc: '' },
          'choclo-a-la-crema': { name: 'Milho com Creme', desc: '' },
          'espinacas-a-la-crema': { name: 'Espinafre com Creme', desc: '' },
          'panache-de-verduras': { name: 'Mix de Legumes', desc: '' },
          'papas-a-la-crema-acida': { name: 'Batatas com Creme Azedo', desc: '' },
          'papas-chauchas': { name: 'Batatas “Chauchas”', desc: '' },
          'papas-cocidas': { name: 'Batatas Cozidas', desc: '' },
          'papas-duquesas': { name: 'Batatas Duquesa', desc: '' },
          'papas-fritas': { name: 'Batatas Fritas', desc: '' },
          'papas-hilo': { name: 'Batatas Palha', desc: '' },
          'papas-salteadas': { name: 'Batatas Salteadas', desc: '' },
          'pure-de-papas': { name: 'Purê de Batata', desc: '' },
          'pure-de-zapallo': { name: 'Purê de Abóbora', desc: '' },
          'pure-gratinado': { name: 'Purê Gratinado', desc: '' }
        },

        'sopas-cremas': {
          'ajiaco': {name: 'Ajiaco', desc: 'Deliciosa preparação feita à base de carne, cebola, batata e pimentão. Opcional Pimenta Cacho de Cabra.'},
          'calderete-de-langosta': {name: 'Caldereta de Lagosta', desc: 'Exquisito caldo de bisque de crustáceos, carne de lagosta, verduras e batatas com coentro fresco.'},
          'caldillo-de-congrio': {name: 'Caldillo de Congrio', desc: 'Tradicional caldo chileno de fumet de peixe, congrio dourado, verduras e batatas com coentro.'},
          'crema-de-centolla': {name: 'Creme de Centolla', desc: 'Exquisito creme de carne de centolla com sofrito, caldo de verduras e creme fresco.'},
          'crema-de-puerros': {name: 'Creme de Alho-poró', desc: 'Delicioso creme de alho-poró e verduras frescas, caldo de verduras e creme fresco.'},
          'crema-de-zapallo': {name: 'Creme de Abóbora', desc: 'Creme natural preparado com abóbora, verduras e um suave toque de creme fresco.'},
          'crema-de-tomate': {name: 'Creme de Tomate', desc: 'Creme natural de tomates frescos com verduras e creme fresco.'},
          'crema-de-esparragos': {name: 'Creme de Aspargos', desc: 'Delicioso creme de aspargos frescos com caldo de verduras.'},
          'sopa-aquarium': {name: 'Sopa Aquarium', desc: 'Delicioso caldo de fumet de peixe, congrio e sortido de frutos do mar, aromatizado com vinho branco.'},
          'consome-ave-reina': {name: 'Consomé Ave Rainha', desc: 'Delicioso caldo de frango com pedaços de frango e verduras.'},
        },

        'ensaladas': {
          'ensalada-cesar': {name: 'Salada Caesar', desc: 'Exquisita salada de alface, rúcula, queijo pecorino em lâminas, croutons e molho francês.'},
          'ensalada-cesar-con-camarones': {name: 'Salada Caesar com Camarões', desc: 'Alface, rúcula, queijo pecorino, camarão empanado em panko, croutons e molho francês.'},
          'ensalada-cesar-con-pollo': {name: 'Salada Caesar com Frango', desc: 'Alface, rúcula, queijo pecorino, frango empanado em panko, croutons e molho francês.'},
          'ensalada-cesar-con-pollo-y-camarones': {name: 'Salada Caesar com Frango e Camarões', desc: 'Alface, queijo pecorino, croutons, frango e camarão, molho francês.'},
          'ensalada-de-manzanas': {name: 'Salada de Maçãs', desc: 'Saborosa combinação de alface, cogumelos, milho, nozes e maçãs vermelhas e/ou verdes.'},
          'ensalada-griega': {name: 'Salada Grega', desc: 'Fresca combinação de tomates, cebola pérola e roxa, pimentão, azeitonas e queijo de cabra.'},
          'ensalada-silvestre': {name: 'Salada Silvestre', desc: 'Fresca combinação de alface, rúcula, agrião, cebola pérola e suculentos gomos de laranjas.'},
          'ensalada-verde': {name: 'Salada Verde', desc: 'Leve combinação de frescas folhas de alface, rúcula, abacate, agrião e espinafre.'},
        },

        'carnes': {
          'asado-de-tira-angus-600-grs': {name: 'Costela Angus 600 grs', desc: 'Exquisita costela Angus, assada na grelha com sal marinho.'},
          'asado-de-tira-angus-800-grs': {name: 'Costela Angus 800 grs', desc: 'Exquisita costela Angus, assada no forno em cozimento lento por 8 horas.'},
          'baby-beef-angus-450-grs': {name: 'Baby Beef Angus 450 grs', desc: 'Saboroso lombo marmoreado angus envolto em bacon e assado na grelha.'},
          'bife-chorizo-wagyu-400-grs': {name: 'Bife Chorizo Wagyu 400 grs', desc: 'Exquisito lombo liso Wagyu assado na grelha. Carne macia com gordura infiltrada que proporciona grande sabor.'},
          'bife-chorizo-angus-400-grs': {name: 'Bife Chorizo Angus 400 grs', desc: 'Exquisito lombo liso Angus assado na grelha com camada de gordura que proporciona grande sabor.'},
          'bife-relleno-solocarnes-400-grs': {name: 'Bife Recheado Solocarnes 400 grs', desc: 'Lombo liso assado com espinafre, bacon, tomate, pimentão e queijo parmesão.'},
          'cordero-de-bulnes-450-grs': {name: 'Cordeiro de Bulnes 450 grs', desc: 'Exquisitos cortes de cordeiro assados, marinados em vinho branco com alecrim e alho, com purê.'},
          'entrana-300-grs': {name: 'Fraldinha 300 grs', desc: 'Corte de grande sabor e maciez, assado na grelha, temperado com sal para churrasqueira.'},
          'entrana-de-wagyu-400-grs': {name: 'Fraldinha de Wagyu 400 grs', desc: 'Corte Wagyu de grande sabor e maciez, assado na grelha com sal para churrasqueira.'},
          'filete-aquarium-300-grs': {name: 'Filé Aquarium 300 grs', desc: 'Medalhão de filé assado, recheado com camarões equatorianos sobre molho de vinho branco.'},
          'filete-grille-300-grs': {name: 'Filé Grelhado 300 grs', desc: 'Saboroso medalhão de filé Angus assado na grelha com sal para churrasqueira.'},
          'porterhouse-steak-700-grs': {name: 'Porterhouse Steak 700 grs', desc: 'Extraordinário corte que reúne lombo liso e filé, temperado com sal marinho.'},
          'plateada-al-horno': {name: 'Plateada ao Forno', desc: 'Saboroso pedaço de plateada assado com verduras e vinho branco em redução de sucos.'},
          'tomahawk-1-5-kgs': {name: 'Tomahawk 1.5 kgs', desc: 'Exquisita costeleta de Lombo Liso/Marmoreado na grelha temperada com sal marinho.'},
        },

        'pescados': {
          'atun-del-ecuador': {name: 'Atum do Equador', desc: 'Exquisito atum equatoriano selado na grelha com ervas finas, merquén e sal.'},
          'congrio-dorado': {name: 'Congrio Dourado', desc: 'Saboroso congrio dourado preparado na manteiga, aromatizado com vinho branco.'},
          'corvina-con-camarones-salteados': {name: 'Corvina com Camarões Salteados', desc: 'Filé de corvina na manteiga com camarões equatorianos salteados ao azeite.'},
          'corvina-grille': {name: 'Corvina Grelhada', desc: 'Delicioso filé de corvina grelhado na manteiga com vinho branco.'},
          'corvina-roulade': {name: 'Corvina Roulade', desc: 'Filé de corvina recheado com camarões, aspargos e alcaparras sobre molho de vinho branco.'},
          'merluza-austral-grille': {name: 'Merluza Austral Grelhada', desc: 'Exquisito filé de merluza austral grelhado com vinho branco.'},
          'salmon-grille-con-camarones': {name: 'Salmão Grelhado com Camarões', desc: 'Filé de salmão na manteiga com camarões equatorianos aromatizados com vinho branco.'},
          'salmon-grille': {name: 'Salmão Grelhado', desc: 'Delicioso filé de salmão preparado na manteiga.'},
        },

        'pastas': {
          'canelones-con-centolla': {name: 'Canelone com Centolla', desc: 'Massa recheada com Centolla, com molho três queijos gratinado com parmesão.'},
          'canelones-con-locos': {name: 'Canelone com Locos', desc: 'Massa recheada com locos, com molho de camarões equatorianos gratinado com parmesão.'},
          'canelones-con-pollo': {name: 'Canelone com Frango', desc: 'Massa recheada com frango, com molho três queijos gratinado com parmesão.'},
          'espagueti': {name: 'Espaguete', desc: 'Exquisita massa fresca, salteada na manteiga ou ao azeite.'},
          'espagueti-al-pesto': {name: 'Espaguete ao Pesto', desc: 'Espaguetes salteados com pasta de manjericão, azeite de oliva, alho e nozes.'},
          'lasana-bolonesa': {name: 'Lasanha Bolonhesa', desc: 'Massa em lâminas com molho bolonhesa, três queijos, mussarela e parmesão gratinado.'},
          'noquis-bolonesa-18-unidades': {name: 'Nhoque Bolonhesa (18 unidades)', desc: 'Massa de batatas, farinha e noz-moscada com molho bolonhesa.'},
          'pappardelle-fruto-di-mare': {name: 'Pappardelle Fruto di Mare', desc: 'Massa de fita salteada com frutos do mar, tomates, manjericão, orégano e creme fresco.'},
          'ravioles-con-espinacas': {name: 'Ravióli com Espinafre', desc: 'Massa recheada com espinafre, queijo parmesão e noz-moscada.'},
          'sorrentinos-de-centolla': {name: 'Sorrentinos de Centolla', desc: 'Massa recheada com centolla, alho-poró, cream cheese e parmesão com manjericão e tomates cereja.'},
        },

        'veganos': {
          'croquetas-de-lentejas-con-salsa-pomodoro': {name: 'Croquetes de Lentilha com Molho Pomodoro', desc: 'Croquetes de lentilha empanados em panko com molho pomodoro e arroz branco.'},
          'hamburguesa-de-garbanzos': {name: 'Hambúrguer de Grão-de-bico', desc: 'Hambúrguer de grão-de-bico e verduras com salada fresca e molho de mostarda.'},
          'quinotto-de-champinones': {name: 'Quinotto de Cogumelos', desc: 'Preparação de quinoa e caldo de verduras com cebolinha fresca e amêndoas torradas.'},
        },

        'celiacos': {
          'espirales-de-arroz-con-camarones': {name: 'Espirais de Arroz com Camarões', desc: 'Massa de farinha de arroz salteada com camarões, verduras, tomates, orégano e manjericão.'},
          'lomo-liso-con-papas-rusticas': {name: 'Lombo Liso com Batatas Rústicas', desc: 'Filé de lombo liso na grelha com sal marinho, batatas rústicas e cenouras salteadas.'},
          'merluza-austral-con-verduras': {name: 'Merluza Austral com Verduras', desc: 'Filé de merluza austral na grelha com verduras e nozes salteadas ao azeite.'},
        },

        'postres': {
          'churros-caseros': {name: 'Churros Caseiros', desc: 'Suave massa frita com açúcar de confeiteiro, acompanhada com doce de leite e sorvete de baunilha.'},
          'creme-brulee': {name: 'Crème Brûlée', desc: 'Delicioso doce francês de creme fresco, gemas de ovo, baunilha e caramelo crocante.'},
          'globo-de-chocolate': {name: 'Globo de Chocolate', desc: 'Delicada esfera de chocolate que esconde uma sobremesa em seu interior.'},
          'helados-artesanales': {name: 'Sorvetes Artesanais', desc: 'Deliciosos sorvetes de elaboração própria.'},
          'leche-asada': {name: 'Leite Assado', desc: 'Fresco doce caseiro de ovos e leite aromatizado com laranja e baunilha.'},
          'panqueque-celestino': {name: 'Panqueca Celestino', desc: 'Panquecas recheadas com doce de leite, açúcar de confeiteiro e sorvete de baunilha.'},
          'papayas-al-jugo': {name: 'Mamões ao Suco', desc: 'Suculentos mamões ao suco, acompanhados com creme espesso opcional.'},
          'picarones': {name: 'Picarones', desc: 'Tradicional sobremesa chilena. Anéis de massa frita de abóbora com molho de Chancaca.'},
          'suspiro-limeno': {name: 'Suspiro Limenho', desc: 'Sobremesa peruana de leite condensado e evaporado, aromatizado com Vinho do Porto e merengue italiano.'},
          'tiramisu': {name: 'Tiramisu', desc: 'Sobremesa italiana de cream cheese, baunilha, vinho envelhecido e café ristretto.'},
          'volcan-de-chocolate': {name: 'Vulcão de Chocolate', desc: 'Bolo de chocolate com centro líquido, acompanhado de sorvete de baunilha.'},
        },

        'salsas': {
          'salsa-4-pimientas': {name: 'Molho 4 Pimentas', desc: 'Preparação à base de molho branco, seleção de 4 pimentas e um toque de creme e conhaque.'},
          'salsa-al-pesto': {name: 'Molho ao Pesto', desc: 'Preparação à base de manjericão, alho, azeite de oliva e nozes.'},
          'salsa-alfredo': {name: 'Molho Alfredo', desc: 'Preparação à base de molho de três queijos e pedaços de presunto.'},
          'salsa-arrabiata': {name: 'Molho Arrabiata', desc: 'Preparação à base de molho de tomate, bacon defumado, alcaparras e um toque de alho, manjericão e merquén.'},
          'salsa-bolonesa': {name: 'Molho Bolonhesa', desc: 'Preparação elaborada à base de molho de tomate, carne moída e verduras.'},
          'salsa-de-centolla': {name: 'Molho de Centolla', desc: 'Suave molho elaborado com carne de centolla, creme fresco e um toque de orégano.'},
          'salsa-de-locos': {name: 'Molho de Locos', desc: 'Delicioso molho elaborado com pedaços de locos, creme fresco e um toque de orégano.'},
          'salsa-de-mostaza': {name: 'Molho de Mostarda', desc: 'Preparação à base de mostarda Dijon, creme fresco e um toque de pimenta.'},
          'salsa-de-pulpo': {name: 'Molho de Polvo', desc: 'Saboroso molho elaborado com pedaços de polvo.'},
          'salsa-pomodoro': {name: 'Molho Pomodoro', desc: 'Saborosa preparação à base de molho de tomate, cebolas, azeitonas e orégano.'},
        },

        'tablas': {
          'tabla-aquarium-4-locos': {name: 'Tábua Aquarium 4 Locos', desc: 'Composta de Locos, Polvo na Grelha, Camarões ao azeite e Machas à parmesana.'},
          'tabla-aquarium-premium': {name: 'Tábua Aquarium Premium', desc: '8 Locos, Polvo na grelha, Centolla desfiada, Camarões ao Azeite e machas à parmesana.'},
          'tabla-de-carnes-y-guacamole': {name: 'Tábua de Carnes e Guacamole', desc: 'Frango, Lombo de Boi e Lombo de Porco salteados com cogumelos e guacamole.'},
          'tabla-mixta-solocarnes': {name: 'Tábua Mista Solocarnes', desc: 'Mix de carnes, frutos do mar e verduras: lombo, frango, camarões panko, lulas com salada fresca.'},
        },
      },
      contact: {
        title: "Contate-nos",
        subtitle: "Estamos aqui para atendê-lo",
        address: "Endereço",
        phone: "Telefone",
        email: "Email",
        schedule: "Horário",
        scheduleText: "Primeira - Sexta: 12:30 - 23:00\nDomingo: 12:30 - 22:00",
        form: {
          name: "Nome",
          email: "Email",
          phone: "Telefone",
          message: "Mensagem",
          send: "Enviar Mensagem",
          success: "Obrigado por nos contatar! Responderemos em breve."
        }
      },
      footer: {
        rights: "Todos os direitos reservados"
      }
    }
  },
  fr: {
    translation: {
      nav: {
        home: "Accueil",
        menu: "Menu",
        about: "À Propos",
        salones: "Nos Espaces",
        contact: "Contact"
      },
      hero: {
        title: "Expérience Premium",
        subtitle: "en Viandes et Fruits de Mer",
        description: "Savourez les morceaux les plus sélects dans une atmosphère d'élégance et de chaleur",
        viewMenu: "Voir le Menu"
      },
      about: {
        title: "Notre Histoire",
        text1: "Chez Aquarium, nous fusionnons la tradition culinaire avec l'excellence contemporaine. Nous nous spécialisons dans les viandes premium et les meilleurs fruits de mer.",
        text2: "Chaque plat est un chef-d'œuvre élaboré avec des ingrédients de la plus haute qualité, préparés par nos chefs experts dans un environnement alliant chaleur et sophistication.",
        years: "Années d'Expérience",
        premium: "Viandes Premium",
        rating: "Évaluation"
      },
      salones: {
        title: "Nos Espaces",
        subtitle: "Ambiances uniques pour chaque occasion",
        cta: "Réserver Maintenant",
        spaces: {
          principal: {
            name: "Salle Principale",
            capacity: "Jusqu'à 80 personnes",
            description: "Notre espace le plus vaste et élégant, parfait pour les grandes célébrations, événements d'entreprise et banquets. Dispose d'un éclairage ambiant réglable, d'un système audio professionnel et d'une décoration sophistiquée.",
            features: ["Climatisation", "Système audio", "Éclairage ambiant", "Accès PMR"]
          },
          privado: {
            name: "Salon Privé VIP",
            capacity: "De 15 à 30 personnes",
            description: "Espace intime et exclusif idéal pour réunions d'affaires, dîners familiaux spéciaux et célébrations privées. Offre une totale intimité avec service personnalisé et menu à la carte.",
            features: ["Totalement privé", "Service exclusif", "Menu personnalisé", "Décoration sur mesure"]
          },
          terraza: {
            name: "Terrasse Extérieure",
            capacity: "Jusqu'à 50 personnes",
            description: "Profitez d'une expérience en plein air sur notre belle terrasse. Parfaite pour événements de jour, cocktails et célébrations décontractées avec vue panoramique et ambiance relaxée.",
            features: ["En plein air", "Vue panoramique", "Chauffage extérieur", "Ambiance naturelle"]
          },
          lounge: {
            name: "Lounge & Bar",
            capacity: "Jusqu'à 40 personnes",
            description: "Espace polyvalent avec ambiance moderne et sophistiquée. Idéal pour after-work, cocktails d'entreprise et réunions sociales. Dispose d'un bar complet et d'un coin salon confortable.",
            features: ["Bar complet", "Musique d'ambiance", "Espace lounge", "Éclairage LED"]
          }
        },
        events: {
          title: "Événements Spéciaux",
          description: "Nous organisons tous types de célébrations",
          types: ["Mariages et Anniversaires", "Événements d'Entreprise", "Anniversaires et Célébrations", "Réunions d'Affaires", "Enterrements de Vie et Baby Showers", "Événements Sociaux"]
        }
      },
      menu: {
        title: "Notre Menu",
        subtitle: "Découvrez nos spécialités",
        categories: {
          "entradas-frias": "Entrées Froides",
          "entradas-calientes": "Entrées Chaudes",
          "agregados": "Suppléments",
          "sopas-cremas": "Soupes et Crèmes",
          "ensaladas": "Salades",
          "carnes": "Viandes Premium",
          "pescados": "Fruits de Mer",
          "pastas": "Pâtes Fraîches",
          "veganos": "Plats Végans",
          "celiacos": "Plats sans Gluten",
          "salsas" : "Sauces",
          "postres": "Desserts",
          "tablas": "Planches et Amuse-gueules"
        }
      },
      menuItems:{
        'entradas-frias': {
          'carpaccio-de-atun': {name: 'Carpaccio de Thon', desc: 'Fines tranches de thon, assaisonnées de sauce moutarde Dijon, mayonnaise et jus de citron, accompagnées de câpres et fromage gruyère.'},
          'carpaccio-de-filete': {name: 'Carpaccio de Filet', desc: 'Fines tranches de filet, assaisonnées de sauce moutarde Dijon, mayonnaise et jus de citron, accompagnées de câpres et fromage gruyère.'},
          'carpaccio-de-salmon': {name: 'Carpaccio de Saumon', desc: 'Fines tranches de saumon, assaisonnées de sauce moutarde Dijon, mayonnaise et jus de citron, accompagnées de câpres et fromage gruyère.'},
          'centolla-del-mar-del-sur': {name: 'Centolla de la Mer du Sud', desc: 'Exquise chair de Centolla, cuite à la vapeur, accompagnée de mayonnaise et sauce verte.'},
          'ceviche-acapulco': {name: 'Ceviche Acapulco', desc: 'Savoureux poisson coupé en cubes et mariné au jus de citron, poivron, oignon rouge, avocat, coriandre, sel et poivre.'},
          'ceviche-de-locos': {name: 'Ceviche de Locos', desc: 'Exquis cubes de locos marinés au jus de citron, poivron, oignon rouge, coriandre, sel et poivre.'},
          'ceviche-de-pulpo': {name: 'Ceviche de Poulpe', desc: 'Savoureux morceaux de poulpe marinés au jus de citron, poivron, oignon rouge, coriandre, sel et poivre.'},
          'ceviche-estilo-mexicano': {name: 'Ceviche Style Mexicain', desc: 'Savoureuses combinaisons de poisson et avocat coupées en cubes, marinées au jus de citron, poivron, oignon rouge, coriandre, piment vert.'},
          'ceviche-de-salmon-acapulco': {name: 'Ceviche de Saumon Acapulco', desc: 'Délicieuse combinaison de saumon, locos et crevettes accompagnée doignon rouge, mélange de poivrons et avocat assaisonnés au jus de citron, sel, poivre et Lait de Tigre.'},
          'ceviche-tropical': {name: 'Ceviche Tropical', desc: 'Fraîche préparation de saumon mariné au jus de citron, poivron, morceaux de mangue, lait de coco, coriandre.'},
          'locos-en-salsa-verde': {name: 'Locos en Sauce Verte', desc: 'Délicieux Locos Premium, accompagnés de mayonnaise et sauce verte. Salade de pommes de terre avec mayonnaise en option.'},
          'tartara-de-filete': {name: 'Tartare de Filet', desc: 'Fines coupes de filet, assaisonnées de câpres, tartare, oignon et coriandre, avec une touche de moutarde, citron et mayonnaise.'},
          'crudo-de-filete': {name: 'Crudo de Filet', desc: 'Fines coupes de filet, assaisonnées d\'oignon et coriandre, avec une touche de citron, sel, poivre et huile d\'olive.'},
        },

        'entradas-calientes': {
          'brocheta-de-camarones-y-jamon-serrano': {name: 'Brochette de Crevettes et Jambon Serrano', desc: 'Délicieuses queues de Crevettes Équatoriennes enroulées dans du jambon serrano, avec sauce tomate, origan et olives noires.'},
          'camarones-ecuatorianos-a-la-primavera': {name: 'Crevettes Équatoriennes à la Primavera', desc: 'Queues de Crevettes Équatoriennes sautées avec oignons, poivrons et tomates cerises. Aromatisées au vin blanc et merquén.'},
          'camarones-al-ajillo': {name: 'Crevettes à l\'Ail', desc: 'Crevettes Équatoriennes sautées à l\'ail, aromatisées au vin blanc et poivre.'},
          'camarones-al-olivo': {name: 'Crevettes à l\'Huile d\'Olive', desc: 'Crevettes Équatoriennes sautées à l\'huile d\'olive avec une touche de poivre.'},
          'camarones-al-pil-pil': {name: 'Crevettes au Pil Pil', desc: 'Crevettes sautées à l\'ail et piment cacho de cabra, aromatisées au vin blanc, poivre et persil.'},
          'langosta-de-juan-fernandez': {name: 'Langouste de Juan Fernández', desc: 'Exquis crustacé bouilli dans un fond de fruits de mer et cuit au four avec beurre aux fines herbes, aromatisé au whisky.'},
          'machas-a-la-parmesana': {name: 'Machas à la Parmesane', desc: 'Savoureuses langues de machas du nord, nappées de sauce trois fromages et gratinées au parmesan.'},
          'ostiones-a-la-parmesana': {name: 'Coquilles Saint-Jacques à la Parmesane', desc: 'Savoureuses Coquilles Saint-Jacques nappées de sauce trois fromages et gratinées au fromage parmesan.'},
          'pulpo-a-la-parrilla': {name: 'Poulpe Grillé', desc: 'Exquis tentacules de Poulpe grillés, macérés à l\'huile d\'olive avec paprika, ail et origan.'},
          'pulpo-salteado-al-ajillo': {name: 'Poulpe Sauté à l\'Ail', desc: 'Tentacules de Poulpe sautés à l\'ail, paprika et vin blanc.'},
          'pulpo-salteado-al-pil-pil': {name: 'Poulpe Sauté au Pil Pil', desc: 'Poulpe sauté à l\'ail, paprika et piment cacho de cabra, aromatisé au vin blanc.'},
          'centolla-entera': {name: 'Centolla Entière', desc: 'Exquis crustacé marin bouilli dans un fond de fruits de mer, monté sur un mélange vert et farci de chair de centolla. Poids approximatif : 3 kg.'},
        },
        'agregados': {
          'anillos-de-cebolla': { name: 'Rondelles d’Oignon', desc: '' },
          'arroz': { name: 'Riz', desc: '' },
          'champinones-salteados': { name: 'Champignons Sautés', desc: '' },
          'choclo-a-la-crema': { name: 'Maïs à la Crème', desc: '' },
          'espinacas-a-la-crema': { name: 'Épinards à la Crème', desc: '' },
          'panache-de-verduras': { name: 'Panaché de Légumes', desc: '' },
          'papas-a-la-crema-acida': { name: 'Pommes de Terre à la Crème Aigre', desc: '' },
          'papas-chauchas': { name: 'Pommes de Terre “Chauchas”', desc: '' },
          'papas-cocidas': { name: 'Pommes de Terre Bouillies', desc: '' },
          'papas-duquesas': { name: 'Pommes Duchesse', desc: '' },
          'papas-fritas': { name: 'Frites', desc: '' },
          'papas-hilo': { name: 'Pommes Allumettes', desc: '' },
          'papas-salteadas': { name: 'Pommes de Terre Sautées', desc: '' },
          'pure-de-papas': { name: 'Purée de Pommes de Terre', desc: '' },
          'pure-de-zapallo': { name: 'Purée de Courge', desc: '' },
          'pure-gratinado': { name: 'Purée Gratinée', desc: '' }
        },
        'sopas-cremas': {
          'ajiaco': {name: 'Ajiaco', desc: 'Délicieuse préparation à base de viande, oignon, pomme de terre et poivron. Piment Cacho de Cabra en option.'},
          'calderete-de-langosta': {name: 'Ragoût de Langouste', desc: 'Exquis bouillon bisque de crustacés, chair de langouste, légumes et pommes de terre avec coriandre fraîche.'},
          'caldillo-de-congrio': {name: 'Caldillo de Congrio', desc: 'Bouillon chilien traditionnel de fumet de poisson, congre doré, légumes et pommes de terre avec coriandre.'},
          'crema-de-centolla': {name: 'Crème de Centolla', desc: 'Exquise crème de chair de centolla avec sofrito, bouillon de légumes et crème fraîche.'},
          'crema-de-puerros': {name: 'Crème de Poireaux', desc: 'Délicieuse crème de poireaux et légumes frais, bouillon de légumes et crème fraîche.'},
          'crema-de-zapallo': {name: 'Crème de Courge', desc: 'Crème naturelle préparée avec courge, légumes et une touche délicate de crème fraîche.'},
          'crema-de-tomate': {name: 'Crème de Tomate', desc: 'Crème naturelle de tomates fraîches avec légumes et crème fraîche.'},
          'crema-de-esparragos': {name: 'Crème d\'Asperges', desc: 'Délicieuse crème d\'asperges fraîches avec bouillon de légumes.'},
          'sopa-aquarium': {name: 'Soupe Aquarium', desc: 'Délicieux bouillon de fumet de poisson, congre et assortiment de fruits de mer, aromatisé au vin blanc.'},
          'consome-ave-reina': {name: 'Consommé Volaille Reine', desc: 'Délicieux bouillon de poulet avec morceaux de poulet et légumes.'},
        },

        'ensaladas': {
          'ensalada-cesar': {name: 'Salade César', desc: 'Exquise salade de laitue, roquette, fromage pecorino en tranches, croûtons et vinaigrette française.'},
          'ensalada-cesar-con-camarones': {name: 'Salade César aux Crevettes', desc: 'Laitue, roquette, fromage pecorino, crevettes panées au panko, croûtons et vinaigrette française.'},
          'ensalada-cesar-con-pollo': {name: 'Salade César au Poulet', desc: 'Laitue, roquette, fromage pecorino, poulet pané au panko, croûtons et vinaigrette française.'},
          'ensalada-cesar-con-pollo-y-camarones': {name: 'Salade César au Poulet et Crevettes', desc: 'Laitue, fromage pecorino, croûtons, poulet et crevettes, vinaigrette française.'},
          'ensalada-de-manzanas': {name: 'Salade de Pommes', desc: 'Savoureuse combinaison de laitue, champignons, maïs, noix et pommes rouges et/ou vertes.'},
          'ensalada-griega': {name: 'Salade Grecque', desc: 'Fraîche combinaison de tomates, oignon perle et rouge, poivron, olives et fromage de chèvre.'},
          'ensalada-silvestre': {name: 'Salade Sauvage', desc: 'Fraîche combinaison de laitue, roquette, cresson, oignon perle et juteux quartiers d\'oranges.'},
          'ensalada-verde': {name: 'Salade Verte', desc: 'Légère combinaison de feuilles fraîches de laitue, roquette, avocat, cresson et épinards.'},
        },

        'carnes': {
          'asado-de-tira-angus-600-grs': {name: 'Côtes Angus 600 grs', desc: 'Exquise côte Angus, grillée au sel de mer.'},
          'asado-de-tira-angus-800-grs': {name: 'Côtes Angus 800 grs', desc: 'Exquise côte Angus, cuite au four à cuisson lente pendant 8 heures.'},
          'baby-beef-angus-450-grs': {name: 'Baby Beef Angus 450 grs', desc: 'Savoureux filet persillé angus enroulé dans du bacon et grillé.'},
          'bife-chorizo-wagyu-400-grs': {name: 'Bife Chorizo Wagyu 400 grs', desc: 'Exquis faux-filet Wagyu grillé. Viande tendre avec graisse infiltrée qui apporte une grande saveur.'},
          'bife-chorizo-angus-400-grs': {name: 'Bife Chorizo Angus 400 grs', desc: 'Exquis faux-filet Angus grillé avec couche de graisse qui apporte une grande saveur.'},
          'bife-relleno-solocarnes-400-grs': {name: 'Bife Farci Solocarnes 400 grs', desc: 'Faux-filet grillé avec épinards, bacon, tomate, poivron et fromage parmesan.'},
          'cordero-de-bulnes-450-grs': {name: 'Agneau de Bulnes 450 grs', desc: 'Exquises coupes d\'agneau grillées, marinées au vin blanc avec romarin et ail, avec purée.'},
          'entrana-300-grs': {name: 'Bavette 300 grs', desc: 'Coupe de grande saveur et tendreté, grillée, assaisonnée au sel de grillade.'},
          'entrana-de-wagyu-400-grs': {name: 'Bavette de Wagyu 400 grs', desc: 'Coupe Wagyu de grande saveur et tendreté, grillée au sel de grillade.'},
          'filete-aquarium-300-grs': {name: 'Filet Aquarium 300 grs', desc: 'Médaillon de filet grillé, farci de crevettes équatoriennes sur sauce au vin blanc.'},
          'filete-grille-300-grs': {name: 'Filet Grillé 300 grs', desc: 'Savoureux médaillon de filet Angus grillé au sel de grillade.'},
          'porterhouse-steak-700-grs': {name: 'Porterhouse Steak 700 grs', desc: 'Extraordinaire coupe qui réunit faux-filet et filet, assaisonné au sel marin.'},
          'plateada-al-horno': {name: 'Poitrine de Bœuf au Four', desc: 'Savoureux morceau de poitrine de bœuf cuit au four avec légumes et vin blanc en réduction de jus.'},
          'tomahawk-1-5-kgs': {name: 'Tomahawk 1.5 kgs', desc: 'Exquise côtelette de Faux-filet/Entrecôte grillée assaisonnée au sel de mer.'},
        },

        'pescados': {
          'atun-del-ecuador': {name: 'Thon d\'Équateur', desc: 'Exquis thon équatorien saisi au grill avec fines herbes, merquén et sel.'},
          'congrio-dorado': {name: 'Congre Doré', desc: 'Savoureux congre doré préparé au beurre, aromatisé au vin blanc.'},
          'corvina-con-camarones-salteados': {name: 'Bar avec Crevettes Sautées', desc: 'Filet de bar au beurre avec crevettes équatoriennes sautées à l\'huile d\'olive.'},
          'corvina-grille': {name: 'Bar Grillé', desc: 'Délicieux filet de bar grillé au beurre avec vin blanc.'},
          'corvina-roulade': {name: 'Bar en Roulade', desc: 'Filet de bar farci de crevettes, asperges et câpres sur sauce au vin blanc.'},
          'merluza-austral-grille': {name: 'Merlu Austral Grillé', desc: 'Exquis filet de merlu austral grillé au vin blanc.'},
          'salmon-grille-con-camarones': {name: 'Saumon Grillé aux Crevettes', desc: 'Filet de saumon au beurre avec crevettes équatoriennes aromatisées au vin blanc.'},
          'salmon-grille': {name: 'Saumon Grillé', desc: 'Délicieux filet de saumon préparé au beurre.'},
        },

        'pastas': {
          'canelones-con-centolla': {name: 'Cannelloni à la Centolla', desc: 'Pâtes farcies à la Centolla, avec sauce trois fromages gratinée au parmesan.'},
          'canelones-con-locos': {name: 'Cannelloni aux Locos', desc: 'Pâtes farcies aux locos, avec sauce aux crevettes équatoriennes gratinée au parmesan.'},
          'canelones-con-pollo': {name: 'Cannelloni au Poulet', desc: 'Pâtes farcies au poulet, avec sauce trois fromages gratinée au parmesan.'},
          'espagueti': {name: 'Spaghetti', desc: 'Exquises pâtes fraîches, sautées au beurre ou à l\'huile d\'olive.'},
          'espagueti-al-pesto': {name: 'Spaghetti au Pesto', desc: 'Spaghettis sautés avec pâte de basilic, huile d\'olive, ail et noix.'},
          'lasana-bolonesa': {name: 'Lasagne Bolognaise', desc: 'Pâtes en feuilles avec sauce bolognaise, trois fromages, mozzarella et parmesan gratinés.'},
          'noquis-bolonesa-18-unidades': {name: 'Gnocchis Bolognaise (18 unités)', desc: 'Pâtes de pommes de terre, farine et noix de muscade avec sauce bolognaise.'},
          'pappardelle-fruto-di-mare': {name: 'Pappardelle Fruto di Mare', desc: 'Pâtes en ruban sautées aux fruits de mer, tomates, basilic, origan et crème fraîche.'},
          'ravioles-con-espinacas': {name: 'Raviolis aux Épinards', desc: 'Pâtes farcies aux épinards, fromage parmesan et noix de muscade.'},
          'sorrentinos-de-centolla': {name: 'Sorrentinos à la Centolla', desc: 'Pâtes farcies à la centolla, poireaux, cream cheese et parmesan avec basilic et tomates cerises.'},
        },

        'veganos': {
          'croquetas-de-lentejas-con-salsa-pomodoro': {name: 'Croquettes de Lentilles avec Sauce Pomodoro', desc: 'Croquettes de lentilles panées au panko avec sauce pomodoro et riz blanc.'},
          'hamburguesa-de-garbanzos': {name: 'Burger de Pois Chiches', desc: 'Burger de pois chiches et légumes avec salade fraîche et sauce moutarde.'},
          'quinotto-de-champinones': {name: 'Quinotto de Champignons', desc: 'Préparation de quinoa et bouillon de légumes avec ciboulette fraîche et amandes grillées.'},
        },

        'celiacos': {
          'espirales-de-arroz-con-camarones': {name: 'Spirales de Riz aux Crevettes', desc: 'Pâtes de farine de riz sautées aux crevettes, légumes, tomates, origan et basilic.'},
          'lomo-liso-con-papas-rusticas': {name: 'Faux-filet avec Pommes de Terre Rustiques', desc: 'Filet de faux-filet grillé au sel de mer, pommes de terre rustiques et carottes sautées.'},
          'merluza-austral-con-verduras': {name: 'Merlu Austral aux Légumes', desc: 'Filet de merlu austral grillé avec légumes et noix sautées à l\'huile d\'olive.'},
        },

        'postres': {
          'churros-caseros': {name: 'Churros Maison', desc: 'Pâte moelleuse frite au sucre glace, accompagnée de confiture de lait et glace vanille.'},
          'creme-brulee': {name: 'Crème Brûlée', desc: 'Délicieux dessert français de crème fraîche, jaunes d\'œufs, vanille et caramel croustillant.'},
          'globo-de-chocolate': {name: 'Globe de Chocolat', desc: 'Délicate sphère de chocolat qui cache un dessert à l\'intérieur.'},
          'helados-artesanales': {name: 'Glaces Artisanales', desc: 'Délicieuses glaces de fabrication maison.'},
          'leche-asada': {name: 'Leche Asada', desc: 'Frais dessert maison d\'œufs et lait aromatisé à l\'orange et vanille.'},
          'panqueque-celestino': {name: 'Crêpe Celestino', desc: 'Crêpes fourrées à la confiture de lait, sucre glace et glace vanille.'},
          'papayas-al-jugo': {name: 'Papayes au Jus', desc: 'Juteuses papayes au jus, accompagnées de crème épaisse en option.'},
          'picarones': {name: 'Picarones', desc: 'Dessert chilien traditionnel. Anneaux de pâte frite à la courge avec sauce Chancaca.'},
          'suspiro-limeno': {name: 'Suspiro Limeño', desc: 'Dessert péruvien de lait concentré et évaporé, aromatisé au Porto et meringue italienne.'},
          'tiramisu': {name: 'Tiramisu', desc: 'Dessert italien de cream cheese, vanille, vin vieux et café ristretto.'},
          'volcan-de-chocolate': {name: 'Volcan de Chocolat', desc: 'Gâteau de chocolat au centre liquide, accompagné de glace vanille.'},
        },

        'salsas': {
          'salsa-4-pimientas': {name: 'Sauce 4 Poivres', desc: 'Préparation à base de sauce blanche, sélection de 4 poivres et une touche de crème et cognac.'},
          'salsa-al-pesto': {name: 'Sauce au Pesto', desc: 'Préparation à base de basilic, ail, huile d\'olive et noix.'},
          'salsa-alfredo': {name: 'Sauce Alfredo', desc: 'Préparation à base de sauce trois fromages et morceaux de jambon.'},
          'salsa-arrabiata': {name: 'Sauce Arrabiata', desc: 'Préparation à base de sauce tomate, bacon fumé, câpres et une touche d\'ail, basilic et merquén.'},
          'salsa-bolonesa': {name: 'Sauce Bolognaise', desc: 'Préparation élaborée à base de sauce tomate, viande hachée et légumes.'},
          'salsa-de-centolla': {name: 'Sauce à la Centolla', desc: 'Sauce onctueuse élaborée avec chair de centolla, crème fraîche et une touche d\'origan.'},
          'salsa-de-locos': {name: 'Sauce aux Locos', desc: 'Délicieuse sauce élaborée avec morceaux de locos, crème fraîche et une touche d\'origan.'},
          'salsa-de-mostaza': {name: 'Sauce Moutarde', desc: 'Préparation à base de moutarde Dijon, crème fraîche et une touche de poivre.'},
          'salsa-de-pulpo': {name: 'Sauce au Poulpe', desc: 'Savoureuse sauce élaborée avec morceaux de poulpe.'},
          'salsa-pomodoro': {name: 'Sauce Pomodoro', desc: 'Savoureuse préparation à base de sauce tomate, oignons, olives et origan.'},
        },

        'tablas': {
          'tabla-aquarium-4-locos': {name: 'Planche Aquarium 4 Locos', desc: 'Composée de Locos, Poulpe Grillé, Crevettes à l\'huile d\'olive et Machas à la parmesane.'},
          'tabla-aquarium-premium': {name: 'Planche Aquarium Premium', desc: '8 Locos, Poulpe grillé, Centolla effilochée, Crevettes à l\'Huile d\'olive et machas à la parmesane.'},
          'tabla-de-carnes-y-guacamole': {name: 'Planche de Viandes et Guacamole', desc: 'Poulet, Filet de Bœuf et Filet de Porc sautés aux champignons et guacamole.'},
          'tabla-mixta-solocarnes': {name: 'Planche Mixte Solocarnes', desc: 'Mélange de viandes, fruits de mer et légumes: bœuf, poulet, crevettes panko, calamars avec salade fraîche.'},
        },
      },
      contact: {
        title: "Contactez-nous",
        subtitle: "Nous sommes là pour vous servir",
        address: "Adresse",
        phone: "Téléphone",
        email: "Email",
        schedule: "Horaires",
        scheduleText: "Lundi - Vendredi: 12:30 - 23:30\nDimanche: 12:30 - 22:00",
        form: {
          name: "Nom",
          email: "Email",
          phone: "Téléphone",
          message: "Message",
          send: "Envoyer le Message",
          success: "Merci de nous avoir contactés! Nous répondrons bientôt."
        }
      },
      footer: {
        rights: "Tous droits réservés"
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;